// @ts-nocheck
import {Routes} from '@angular/router';

export const NG_DOC_ROUTING: Routes = [
	
	{
		path: 'api',
		title: `API Reference`,
		loadChildren: () => import('./api/page'),
	},
	
	{
		path: 'api/classes/apollo-api/ApolloProvidersModule',
		title: `ApolloProvidersModule`,
		loadChildren: () => import('./api/api/classes/apollo-api/ApolloProvidersModule/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/FeatureFlagLookkup',
		title: `FeatureFlagLookkup`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/FeatureFlagLookkup/page'),
	},
	
	{
		path: 'api/variables/apollo-api/configureApolloWithFeatureFlags',
		title: `configureApolloWithFeatureFlags`,
		loadChildren: () => import('./api/api/variables/apollo-api/configureApolloWithFeatureFlags/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout',
		title: `useApolloLayout`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout_Refresh',
		title: `useApolloLayout_Refresh`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout_Refresh/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout_Learner_V2',
		title: `useApolloLayout_Learner_V2`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout_Learner_V2/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout_Admin_V2',
		title: `useApolloLayout_Admin_V2`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout_Admin_V2/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout_Learner_V3',
		title: `useApolloLayout_Learner_V3`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout_Learner_V3/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useApolloLayout_Admin_V3',
		title: `useApolloLayout_Admin_V3`,
		loadChildren: () => import('./api/api/variables/apollo-api/useApolloLayout_Admin_V3/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useAdminCx',
		title: `useAdminCx`,
		loadChildren: () => import('./api/api/variables/apollo-api/useAdminCx/page'),
	},
	
	{
		path: 'api/variables/apollo-api/useLearnerCx',
		title: `useLearnerCx`,
		loadChildren: () => import('./api/api/variables/apollo-api/useLearnerCx/page'),
	},
	
	{
		path: 'api/variables/apollo-api/FEATURE_FLAGS',
		title: `FEATURE_FLAGS`,
		loadChildren: () => import('./api/api/variables/apollo-api/FEATURE_FLAGS/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/LayoutConfiguration_v2',
		title: `LayoutConfiguration_v2`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/LayoutConfiguration_v2/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ConfirmProps',
		title: `ConfirmProps`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ConfirmProps/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ConfirmationMode',
		title: `ConfirmationMode`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ConfirmationMode/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ConfirmationTheme',
		title: `ConfirmationTheme`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ConfirmationTheme/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/InfoType',
		title: `InfoType`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/InfoType/page'),
	},
	
	{
		path: 'api/classes/apollo-api/ConfirmComponent',
		title: `ConfirmComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/ConfirmComponent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DropdownRowItem',
		title: `DropdownRowItem`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DropdownRowItem/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DropdownComponent',
		title: `DropdownComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DropdownComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/FooterComponent',
		title: `FooterComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/FooterComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/HeaderComponent',
		title: `HeaderComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/HeaderComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavDisclosureComponent',
		title: `NavDisclosureComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavDisclosureComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavIconComponent',
		title: `NavIconComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavIconComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavItemComponent',
		title: `NavItemComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavItemComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavPopoverComponent',
		title: `NavPopoverComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavPopoverComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SidebarComponent',
		title: `SidebarComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SidebarComponent/page'),
	},
	
	{
		path: 'api/variables/apollo-api/defaultConfiguration',
		title: `defaultConfiguration`,
		loadChildren: () => import('./api/api/variables/apollo-api/defaultConfiguration/page'),
	},
	
	{
		path: 'api/classes/apollo-api/LayoutComponent',
		title: `LayoutComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/LayoutComponent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutColors',
		title: `LayoutColors`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutColors/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutLogo',
		title: `LayoutLogo`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutLogo/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutBrand',
		title: `LayoutBrand`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutBrand/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutBaseNavigation',
		title: `LayoutBaseNavigation`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutBaseNavigation/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutFeature',
		title: `LayoutFeature`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutFeature/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutFeatures',
		title: `LayoutFeatures`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutFeatures/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutNavigationItem',
		title: `LayoutNavigationItem`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutNavigationItem/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutNavigation',
		title: `LayoutNavigation`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutNavigation/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutAspect',
		title: `LayoutAspect`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutAspect/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutConfiguration',
		title: `LayoutConfiguration`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutConfiguration/page'),
	},
	
	{
		path: 'api/variables/apollo-api/APOLLO_LAYOUT_BRANDING',
		title: `APOLLO_LAYOUT_BRANDING`,
		loadChildren: () => import('./api/api/variables/apollo-api/APOLLO_LAYOUT_BRANDING/page'),
	},
	
	{
		path: 'api/variables/apollo-api/isItemActive',
		title: `isItemActive`,
		loadChildren: () => import('./api/api/variables/apollo-api/isItemActive/page'),
	},
	
	{
		path: 'api/variables/apollo-api/getActiveChild',
		title: `getActiveChild`,
		loadChildren: () => import('./api/api/variables/apollo-api/getActiveChild/page'),
	},
	
	{
		path: 'api/variables/apollo-api/findActiveItemWithTitle',
		title: `findActiveItemWithTitle`,
		loadChildren: () => import('./api/api/variables/apollo-api/findActiveItemWithTitle/page'),
	},
	
	{
		path: 'api/classes/apollo-api/ProgressToastComponent',
		title: `ProgressToastComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/ProgressToastComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/ToastComponent',
		title: `ToastComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/ToastComponent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/ToastOptions',
		title: `ToastOptions`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/ToastOptions/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/ProgressToastOptions',
		title: `ProgressToastOptions`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/ProgressToastOptions/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/ProgressToastEvent',
		title: `ProgressToastEvent`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/ProgressToastEvent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/IconStyle',
		title: `IconStyle`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/IconStyle/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/IconType',
		title: `IconType`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/IconType/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ProgressIconType',
		title: `ProgressIconType`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ProgressIconType/page'),
	},
	
	{
		path: 'api/variables/apollo-api/initToastOptions',
		title: `initToastOptions`,
		loadChildren: () => import('./api/api/variables/apollo-api/initToastOptions/page'),
	},
	
	{
		path: 'api/variables/apollo-api/initProgressToastOptions',
		title: `initProgressToastOptions`,
		loadChildren: () => import('./api/api/variables/apollo-api/initProgressToastOptions/page'),
	},
	
	{
		path: 'api/variables/apollo-api/toastAnimations',
		title: `toastAnimations`,
		loadChildren: () => import('./api/api/variables/apollo-api/toastAnimations/page'),
	},
	
	{
		path: 'api/variables/apollo-api/TOAST_DATA',
		title: `TOAST_DATA`,
		loadChildren: () => import('./api/api/variables/apollo-api/TOAST_DATA/page'),
	},
	
	{
		path: 'api/variables/apollo-api/PROGRESS_TOAST_DATA',
		title: `PROGRESS_TOAST_DATA`,
		loadChildren: () => import('./api/api/variables/apollo-api/PROGRESS_TOAST_DATA/page'),
	},
	
	{
		path: 'api/classes/apollo-api/InputComponent',
		title: `InputComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/InputComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/TextareaComponent',
		title: `TextareaComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/TextareaComponent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/BreadcrumbItem',
		title: `BreadcrumbItem`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/BreadcrumbItem/page'),
	},
	
	{
		path: 'api/classes/apollo-api/BreadcrumbComponent',
		title: `BreadcrumbComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/BreadcrumbComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/PaginationComponent',
		title: `PaginationComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/PaginationComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SkipNavComponent',
		title: `SkipNavComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SkipNavComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/AlertComponent',
		title: `AlertComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/AlertComponent/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/TabConfig',
		title: `TabConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/TabConfig/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/TabsConfiguration',
		title: `TabsConfiguration`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/TabsConfiguration/page'),
	},
	
	{
		path: 'api/classes/apollo-api/TabsComponent',
		title: `TabsComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/TabsComponent/page'),
	},
	
	{
		path: 'api/enums/apollo-api/AvatarSize',
		title: `AvatarSize`,
		loadChildren: () => import('./api/api/enums/apollo-api/AvatarSize/page'),
	},
	
	{
		path: 'api/classes/apollo-api/AvatarComponent',
		title: `AvatarComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/AvatarComponent/page'),
	},
	
	{
		path: 'api/functions/apollo-api/iconComponent',
		title: `iconComponent`,
		loadChildren: () => import('./api/api/functions/apollo-api/iconComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/IconComponent',
		title: `IconComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/IconComponent/page'),
	},
	
	{
		path: 'api/variables/apollo-api/twMerge',
		title: `twMerge`,
		loadChildren: () => import('./api/api/variables/apollo-api/twMerge/page'),
	},
	
	{
		path: 'api/functions/apollo-api/twJoin',
		title: `twJoin`,
		loadChildren: () => import('./api/api/functions/apollo-api/twJoin/page'),
	},
	
	{
		path: 'api/functions/apollo-api/useActionKey',
		title: `useActionKey`,
		loadChildren: () => import('./api/api/functions/apollo-api/useActionKey/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/KeyboardEventModifierKey',
		title: `KeyboardEventModifierKey`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/KeyboardEventModifierKey/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ActionKey',
		title: `ActionKey`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ActionKey/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DialogData',
		title: `DialogData`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DialogData/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DialogService',
		title: `DialogService`,
		loadChildren: () => import('./api/api/classes/apollo-api/DialogService/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ProgressUpdate',
		title: `ProgressUpdate`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ProgressUpdate/page'),
	},
	
	{
		path: 'api/variables/apollo-api/AUTO_CLOSE_FALLBACK',
		title: `AUTO_CLOSE_FALLBACK`,
		loadChildren: () => import('./api/api/variables/apollo-api/AUTO_CLOSE_FALLBACK/page'),
	},
	
	{
		path: 'api/classes/apollo-api/ToastService',
		title: `ToastService`,
		loadChildren: () => import('./api/api/classes/apollo-api/ToastService/page'),
	},
	
	{
		path: 'api/classes/apollo-api/BreadcrumbsService',
		title: `BreadcrumbsService`,
		loadChildren: () => import('./api/api/classes/apollo-api/BreadcrumbsService/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerService',
		title: `DrawerService`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerService/page'),
	},
	
	{
		path: 'api/variables/apollo-api/screenReaderTextForLogo',
		title: `screenReaderTextForLogo`,
		loadChildren: () => import('./api/api/variables/apollo-api/screenReaderTextForLogo/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/AlertTheme',
		title: `AlertTheme`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/AlertTheme/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/AlertEventType',
		title: `AlertEventType`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/AlertEventType/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/AlertButtonModel',
		title: `AlertButtonModel`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/AlertButtonModel/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/AlertItemModel',
		title: `AlertItemModel`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/AlertItemModel/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/AlertConfig',
		title: `AlertConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/AlertConfig/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/AvatarConfig',
		title: `AvatarConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/AvatarConfig/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerAnimationWrapperComponent',
		title: `DrawerAnimationWrapperComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerAnimationWrapperComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerComponent',
		title: `DrawerComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerComponent/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/DrawerResultType',
		title: `DrawerResultType`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/DrawerResultType/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerConfig',
		title: `DrawerConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerConfig/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerButtonsConfig',
		title: `DrawerButtonsConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerButtonsConfig/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerButtonConfig',
		title: `DrawerButtonConfig`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerButtonConfig/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerState',
		title: `DrawerState`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerState/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerButtons',
		title: `DrawerButtons`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerButtons/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerButton',
		title: `DrawerButton`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerButton/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerResult',
		title: `DrawerResult`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerResult/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/DrawerComponentInputs',
		title: `DrawerComponentInputs`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/DrawerComponentInputs/page'),
	},
	
	{
		path: 'api/classes/apollo-api/FooterComponent_v2',
		title: `FooterComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/FooterComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/HeaderComponent_v2',
		title: `HeaderComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/HeaderComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavDisclosureComponent_v2',
		title: `NavDisclosureComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavDisclosureComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavIconComponent_v2',
		title: `NavIconComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavIconComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavItemComponent_v2',
		title: `NavItemComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavItemComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/NavPopoverComponent_v2',
		title: `NavPopoverComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/NavPopoverComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SidebarComponent_v2',
		title: `SidebarComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/SidebarComponent_v2/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SwitcherDisclosureComponent',
		title: `SwitcherDisclosureComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SwitcherDisclosureComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SwitcherItemComponent',
		title: `SwitcherItemComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SwitcherItemComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SwitcherPopoverComponent',
		title: `SwitcherPopoverComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SwitcherPopoverComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/LayoutComponent_v2',
		title: `LayoutComponent_v2`,
		loadChildren: () => import('./api/api/classes/apollo-api/LayoutComponent_v2/page'),
	},
	
	{
		path: 'api/type-aliases/apollo-api/ProductKey',
		title: `ProductKey`,
		loadChildren: () => import('./api/api/type-aliases/apollo-api/ProductKey/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutSwitcherNavigationItem',
		title: `LayoutSwitcherNavigationItem`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutSwitcherNavigationItem/page'),
	},
	
	{
		path: 'api/interfaces/apollo-api/LayoutSwitcherNavigation',
		title: `LayoutSwitcherNavigation`,
		loadChildren: () => import('./api/api/interfaces/apollo-api/LayoutSwitcherNavigation/page'),
	},
	
	{
		path: 'api/variables/apollo-api/paginate',
		title: `paginate`,
		loadChildren: () => import('./api/api/variables/apollo-api/paginate/page'),
	},
	
	{
		path: 'api/variables/apollo-api/calcTotalPages',
		title: `calcTotalPages`,
		loadChildren: () => import('./api/api/variables/apollo-api/calcTotalPages/page'),
	},
	
	{
		path: 'api/variables/apollo-api/calcPreviousPage',
		title: `calcPreviousPage`,
		loadChildren: () => import('./api/api/variables/apollo-api/calcPreviousPage/page'),
	},
	
	{
		path: 'api/variables/apollo-api/calcNextPage',
		title: `calcNextPage`,
		loadChildren: () => import('./api/api/variables/apollo-api/calcNextPage/page'),
	},
	
	{
		path: 'api/variables/apollo-api/calcStartIndex',
		title: `calcStartIndex`,
		loadChildren: () => import('./api/api/variables/apollo-api/calcStartIndex/page'),
	},
	
	{
		path: 'api/variables/apollo-api/calcEndIndex',
		title: `calcEndIndex`,
		loadChildren: () => import('./api/api/variables/apollo-api/calcEndIndex/page'),
	},
	
	{
		path: 'api/classes/apollo-api/A11yService',
		title: `A11yService`,
		loadChildren: () => import('./api/api/classes/apollo-api/A11yService/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerFooterComponent',
		title: `DrawerFooterComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerFooterComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerHeaderComponent',
		title: `DrawerHeaderComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerHeaderComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/DrawerExampleComponent',
		title: `DrawerExampleComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/DrawerExampleComponent/page'),
	},
	
	{
		path: 'api/classes/apollo-api/SimpleDrawerExampleComponent',
		title: `SimpleDrawerExampleComponent`,
		loadChildren: () => import('./api/api/classes/apollo-api/SimpleDrawerExampleComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AuthorizedRoute',
		title: `AuthorizedRoute`,
		loadChildren: () => import('./api/api/classes/lxp-api/AuthorizedRoute/page'),
	},
	
	{
		path: 'api/classes/lxp-api/RequestCache',
		title: `RequestCache`,
		loadChildren: () => import('./api/api/classes/lxp-api/RequestCache/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CachedHttpRequest',
		title: `CachedHttpRequest`,
		loadChildren: () => import('./api/api/classes/lxp-api/CachedHttpRequest/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CachingInterceptor',
		title: `CachingInterceptor`,
		loadChildren: () => import('./api/api/classes/lxp-api/CachingInterceptor/page'),
	},
	
	{
		path: 'api/functions/lxp-api/createTranslateLoader',
		title: `createTranslateLoader`,
		loadChildren: () => import('./api/api/functions/lxp-api/createTranslateLoader/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TranslationTable',
		title: `TranslationTable`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TranslationTable/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgTranslateDynamicLoader',
		title: `DgTranslateDynamicLoader`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgTranslateDynamicLoader/page'),
	},
	
	{
		path: 'api/variables/lxp-api/DraggableToken',
		title: `DraggableToken`,
		loadChildren: () => import('./api/api/variables/lxp-api/DraggableToken/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isKey',
		title: `isKey`,
		loadChildren: () => import('./api/api/functions/lxp-api/isKey/page'),
	},
	
	{
		path: 'api/enums/lxp-api/Key',
		title: `Key`,
		loadChildren: () => import('./api/api/enums/lxp-api/Key/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LocalizationService',
		title: `LocalizationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/LocalizationService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NgxHttpClient',
		title: `NgxHttpClient`,
		loadChildren: () => import('./api/api/classes/lxp-api/NgxHttpClient/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NgxHttpParamUriEncoder',
		title: `NgxHttpParamUriEncoder`,
		loadChildren: () => import('./api/api/classes/lxp-api/NgxHttpParamUriEncoder/page'),
	},
	
	{
		path: 'api/variables/lxp-api/NUM_RESULTS_PER_PAGE',
		title: `NUM_RESULTS_PER_PAGE`,
		loadChildren: () => import('./api/api/variables/lxp-api/NUM_RESULTS_PER_PAGE/page'),
	},
	
	{
		path: 'api/variables/lxp-api/NUM_TILE_RESULTS_PER_PAGE',
		title: `NUM_TILE_RESULTS_PER_PAGE`,
		loadChildren: () => import('./api/api/variables/lxp-api/NUM_TILE_RESULTS_PER_PAGE/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TypeaheadSearchTerm',
		title: `TypeaheadSearchTerm`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TypeaheadSearchTerm/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TypeaheadSearchFunction',
		title: `TypeaheadSearchFunction`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TypeaheadSearchFunction/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SharedProvidersModule',
		title: `SharedProvidersModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/SharedProvidersModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SharedModule',
		title: `SharedModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/SharedModule/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ButtonType',
		title: `ButtonType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ButtonType/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/WebEnvironmentInfo',
		title: `WebEnvironmentInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/WebEnvironmentInfo/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/XSRFCache',
		title: `XSRFCache`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/XSRFCache/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/AnalyticsConfiguration',
		title: `AnalyticsConfiguration`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/AnalyticsConfiguration/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/AnalyticsAppLocation',
		title: `AnalyticsAppLocation`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/AnalyticsAppLocation/page'),
	},
	
	{
		path: 'api/enums/lxp-api/ApplicationId',
		title: `ApplicationId`,
		loadChildren: () => import('./api/api/enums/lxp-api/ApplicationId/page'),
	},
	
	{
		path: 'api/functions/lxp-api/windowProvider',
		title: `windowProvider`,
		loadChildren: () => import('./api/api/functions/lxp-api/windowProvider/page'),
	},
	
	{
		path: 'api/variables/lxp-api/WindowToken',
		title: `WindowToken`,
		loadChildren: () => import('./api/api/variables/lxp-api/WindowToken/page'),
	},
	
	{
		path: 'api/variables/lxp-api/fadeIn',
		title: `fadeIn`,
		loadChildren: () => import('./api/api/variables/lxp-api/fadeIn/page'),
	},
	
	{
		path: 'api/variables/lxp-api/fadeInAndOut',
		title: `fadeInAndOut`,
		loadChildren: () => import('./api/api/variables/lxp-api/fadeInAndOut/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AutofocusDirective',
		title: `AutofocusDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/AutofocusDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ClickOutsideDirective',
		title: `ClickOutsideDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/ClickOutsideDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DatepickerDataDgatDirective',
		title: `DatepickerDataDgatDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/DatepickerDataDgatDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FallbackDirective',
		title: `FallbackDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/FallbackDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FeatureToggleDirective',
		title: `FeatureToggleDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/FeatureToggleDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ImageRatioDirective',
		title: `ImageRatioDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/ImageRatioDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/IntersectionObserverDirective',
		title: `IntersectionObserverDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/IntersectionObserverDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MaxTimeValidationDirective',
		title: `MaxTimeValidationDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/MaxTimeValidationDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MinTimeValidationDirective',
		title: `MinTimeValidationDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/MinTimeValidationDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PasteAsPlainTextDirective',
		title: `PasteAsPlainTextDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/PasteAsPlainTextDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/RecaptchaDirective',
		title: `RecaptchaDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/RecaptchaDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SecureBlankTargetDirective',
		title: `SecureBlankTargetDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SecureBlankTargetDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SetFocusDirective',
		title: `SetFocusDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SetFocusDirective/page'),
	},
	
	{
		path: 'api/functions/lxp-api/checkSoftLimit',
		title: `checkSoftLimit`,
		loadChildren: () => import('./api/api/functions/lxp-api/checkSoftLimit/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SoftLimitValidatorDirective',
		title: `SoftLimitValidatorDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SoftLimitValidatorDirective/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SortableResult',
		title: `SortableResult`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SortableResult/page'),
	},
	
	{
		path: 'api/variables/lxp-api/SORTABLE_LIST_TOKEN',
		title: `SORTABLE_LIST_TOKEN`,
		loadChildren: () => import('./api/api/variables/lxp-api/SORTABLE_LIST_TOKEN/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SortableListDirective',
		title: `SortableListDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SortableListDirective/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Sortable',
		title: `Sortable`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Sortable/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SortableDirective',
		title: `SortableDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SortableDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/StickyDirective',
		title: `StickyDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/StickyDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TrackingAreaDirective',
		title: `TrackingAreaDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/TrackingAreaDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TrapFocusDirective',
		title: `TrapFocusDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/TrapFocusDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ComponentFactoryService',
		title: `ComponentFactoryService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ComponentFactoryService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LoaderDirective',
		title: `LoaderDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/LoaderDirective/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ComponentContext',
		title: `ComponentContext`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ComponentContext/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AuthInterceptor',
		title: `AuthInterceptor`,
		loadChildren: () => import('./api/api/classes/lxp-api/AuthInterceptor/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InterceptorsModule',
		title: `InterceptorsModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/InterceptorsModule/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/HttpHandlerFn',
		title: `HttpHandlerFn`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/HttpHandlerFn/page'),
	},
	
	{
		path: 'api/classes/lxp-api/XSRFTokenInterceptor',
		title: `XSRFTokenInterceptor`,
		loadChildren: () => import('./api/api/classes/lxp-api/XSRFTokenInterceptor/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/MenuOption',
		title: `MenuOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/MenuOption/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ActionConfig',
		title: `ActionConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ActionConfig/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ReferenceOwner',
		title: `ReferenceOwner`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ReferenceOwner/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Facet',
		title: `Facet`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Facet/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FacetValue',
		title: `FacetValue`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FacetValue/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/BuildFilterParams',
		title: `BuildFilterParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/BuildFilterParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Resource',
		title: `Resource`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Resource/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ResourceIdentifier',
		title: `ResourceIdentifier`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ResourceIdentifier/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Reference',
		title: `Reference`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Reference/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/RecommendationReference',
		title: `RecommendationReference`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/RecommendationReference/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ReferenceIdentifier',
		title: `ReferenceIdentifier`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ReferenceIdentifier/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ResourceOwner',
		title: `ResourceOwner`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ResourceOwner/page'),
	},
	
	{
		path: 'api/enums/lxp-api/ResourcePrivacyLevel',
		title: `ResourcePrivacyLevel`,
		loadChildren: () => import('./api/api/enums/lxp-api/ResourcePrivacyLevel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ImageOwner',
		title: `ImageOwner`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ImageOwner/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ImageSize',
		title: `ImageSize`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ImageSize/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Providable',
		title: `Providable`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Providable/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/LearningResource',
		title: `LearningResource`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/LearningResource/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ProviderLearningResourceOwner',
		title: `ProviderLearningResourceOwner`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ProviderLearningResourceOwner/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TargetType',
		title: `TargetType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TargetType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TargetSuggestionType',
		title: `TargetSuggestionType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TargetSuggestionType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/MediaInputType',
		title: `MediaInputType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/MediaInputType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/SessionedInputType',
		title: `SessionedInputType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/SessionedInputType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/InputType',
		title: `InputType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/InputType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/OutcomeType',
		title: `OutcomeType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/OutcomeType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/LearningResourceType',
		title: `LearningResourceType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/LearningResourceType/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ResourceType',
		title: `ResourceType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ResourceType/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/JsonObject',
		title: `JsonObject`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/JsonObject/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/JsonObjectOrString',
		title: `JsonObjectOrString`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/JsonObjectOrString/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/FlexibleDate',
		title: `FlexibleDate`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/FlexibleDate/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/RecommendationInfo',
		title: `RecommendationInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/RecommendationInfo/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/HostedContentMetadata',
		title: `HostedContentMetadata`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/HostedContentMetadata/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SimpleItemViewModel',
		title: `SimpleItemViewModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SimpleItemViewModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ParentItemViewModel',
		title: `ParentItemViewModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ParentItemViewModel/page'),
	},
	
	{
		path: 'api/enums/lxp-api/UserRecommendationType',
		title: `UserRecommendationType`,
		loadChildren: () => import('./api/api/enums/lxp-api/UserRecommendationType/page'),
	},
	
	{
		path: 'api/enums/lxp-api/MediaParseType',
		title: `MediaParseType`,
		loadChildren: () => import('./api/api/enums/lxp-api/MediaParseType/page'),
	},
	
	{
		path: 'api/enums/lxp-api/OrganizationType',
		title: `OrganizationType`,
		loadChildren: () => import('./api/api/enums/lxp-api/OrganizationType/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isDgError',
		title: `isDgError`,
		loadChildren: () => import('./api/api/functions/lxp-api/isDgError/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgError',
		title: `DgError`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgError/page'),
	},
	
	{
		path: 'api/enums/lxp-api/ErrorType',
		title: `ErrorType`,
		loadChildren: () => import('./api/api/enums/lxp-api/ErrorType/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ListViewModel',
		title: `ListViewModel`,
		loadChildren: () => import('./api/api/classes/lxp-api/ListViewModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OrgHomeLayoutConfiguration',
		title: `OrgHomeLayoutConfiguration`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OrgHomeLayoutConfiguration/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OrgHomeComponentReference',
		title: `OrgHomeComponentReference`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OrgHomeComponentReference/page'),
	},
	
	{
		path: 'api/enums/lxp-api/OrgHomeSchemaName',
		title: `OrgHomeSchemaName`,
		loadChildren: () => import('./api/api/enums/lxp-api/OrgHomeSchemaName/page'),
	},
	
	{
		path: 'api/enums/lxp-api/OrgHomeComponentForReorder',
		title: `OrgHomeComponentForReorder`,
		loadChildren: () => import('./api/api/enums/lxp-api/OrgHomeComponentForReorder/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/RadioOption',
		title: `RadioOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/RadioOption/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/RecommendActions',
		title: `RecommendActions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/RecommendActions/page'),
	},
	
	{
		path: 'api/classes/lxp-api/Trackable',
		title: `Trackable`,
		loadChildren: () => import('./api/api/classes/lxp-api/Trackable/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AnchorifyPipe',
		title: `AnchorifyPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/AnchorifyPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BlobifyUrlPipe',
		title: `BlobifyUrlPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/BlobifyUrlPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CamelCasePipe',
		title: `CamelCasePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/CamelCasePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ChunkedPipe',
		title: `ChunkedPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/ChunkedPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ClosestWordLimitPipe',
		title: `ClosestWordLimitPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/ClosestWordLimitPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContentActionPipe',
		title: `ContentActionPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContentActionPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxCurrencyPipe',
		title: `DgxCurrencyPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxCurrencyPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DecodeHtmlPipe',
		title: `DecodeHtmlPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/DecodeHtmlPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DisplayTypePipe',
		title: `DisplayTypePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/DisplayTypePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EllipsisPipe',
		title: `EllipsisPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/EllipsisPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EncodeToEntitiesPipe',
		title: `EncodeToEntitiesPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/EncodeToEntitiesPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EscapeCurlysPipe',
		title: `EscapeCurlysPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/EscapeCurlysPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FileSizePipe',
		title: `FileSizePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/FileSizePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GetSkillTypePipe',
		title: `GetSkillTypePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/GetSkillTypePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HighlightSearchTextPipe',
		title: `HighlightSearchTextPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/HighlightSearchTextPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HtmlTranslatedPipe',
		title: `HtmlTranslatedPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/HtmlTranslatedPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HtmlPipe',
		title: `HtmlPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/HtmlPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HtmlToPlaintextPipe',
		title: `HtmlToPlaintextPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/HtmlToPlaintextPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InputToLearningResourcePipe',
		title: `InputToLearningResourcePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/InputToLearningResourcePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/IsIframePipe',
		title: `IsIframePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/IsIframePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NgbDatePipe',
		title: `NgbDatePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/NgbDatePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrderByPipe',
		title: `OrderByPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrderByPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PascalCasePipe',
		title: `PascalCasePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/PascalCasePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PointsPipe',
		title: `PointsPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/PointsPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PrettyDurationPipe',
		title: `PrettyDurationPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/PrettyDurationPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PrettyTimeElapsedPipe',
		title: `PrettyTimeElapsedPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/PrettyTimeElapsedPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PrivacyLevelFilterPipe',
		title: `PrivacyLevelFilterPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/PrivacyLevelFilterPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ResourceTypeIconPipe',
		title: `ResourceTypeIconPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/ResourceTypeIconPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SafePipe',
		title: `SafePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/SafePipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchByPipe',
		title: `SearchByPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchByPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SlugifyPipe',
		title: `SlugifyPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/SlugifyPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/StripMarkupPipe',
		title: `StripMarkupPipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/StripMarkupPipe/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UnicodePipe',
		title: `UnicodePipe`,
		loadChildren: () => import('./api/api/classes/lxp-api/UnicodePipe/page'),
	},
	
	{
		path: 'api/functions/lxp-api/compareState',
		title: `compareState`,
		loadChildren: () => import('./api/api/functions/lxp-api/compareState/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/State',
		title: `State`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/State/page'),
	},
	
	{
		path: 'api/functions/lxp-api/withStatus',
		title: `withStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/withStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/catchErrorWith',
		title: `catchErrorWith`,
		loadChildren: () => import('./api/api/functions/lxp-api/catchErrorWith/page'),
	},
	
	{
		path: 'api/functions/lxp-api/trackRequestStatus',
		title: `trackRequestStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/trackRequestStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/selectRequestStatus',
		title: `selectRequestStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/selectRequestStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/selectLoadingStatus',
		title: `selectLoadingStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/selectLoadingStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/selectInitializingStatus',
		title: `selectInitializingStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/selectInitializingStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/selectReadyStatus',
		title: `selectReadyStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/selectReadyStatus/page'),
	},
	
	{
		path: 'api/functions/lxp-api/updateRequestStatus',
		title: `updateRequestStatus`,
		loadChildren: () => import('./api/api/functions/lxp-api/updateRequestStatus/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/StatusState',
		title: `StatusState`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/StatusState/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SuccessState',
		title: `SuccessState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SuccessState/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PendingState',
		title: `PendingState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PendingState/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/InitializingState',
		title: `InitializingState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/InitializingState/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ErrorState',
		title: `ErrorState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ErrorState/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getRequestStatus',
		title: `getRequestStatus`,
		loadChildren: () => import('./api/api/variables/lxp-api/getRequestStatus/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getIsInitializing',
		title: `getIsInitializing`,
		loadChildren: () => import('./api/api/variables/lxp-api/getIsInitializing/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getIsLoading',
		title: `getIsLoading`,
		loadChildren: () => import('./api/api/variables/lxp-api/getIsLoading/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getIsReady',
		title: `getIsReady`,
		loadChildren: () => import('./api/api/variables/lxp-api/getIsReady/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getError',
		title: `getError`,
		loadChildren: () => import('./api/api/variables/lxp-api/getError/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TrackRequest',
		title: `TrackRequest`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TrackRequest/page'),
	},
	
	{
		path: 'api/variables/lxp-api/makeTrackRequest',
		title: `makeTrackRequest`,
		loadChildren: () => import('./api/api/variables/lxp-api/makeTrackRequest/page'),
	},
	
	{
		path: 'api/functions/lxp-api/findPage',
		title: `findPage`,
		loadChildren: () => import('./api/api/functions/lxp-api/findPage/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PaginationProps',
		title: `PaginationProps`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PaginationProps/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PaginationApi',
		title: `PaginationApi`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PaginationApi/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PaginatedStore',
		title: `PaginatedStore`,
		loadChildren: () => import('./api/api/classes/lxp-api/PaginatedStore/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ReactiveListVM',
		title: `ReactiveListVM`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ReactiveListVM/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ListState',
		title: `ListState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ListState/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReactiveList',
		title: `ReactiveList`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReactiveList/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReactiveStore',
		title: `ReactiveStore`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReactiveStore/page'),
	},
	
	{
		path: 'api/functions/lxp-api/freezeStores',
		title: `freezeStores`,
		loadChildren: () => import('./api/api/functions/lxp-api/freezeStores/page'),
	},
	
	{
		path: 'api/functions/lxp-api/initStoreState',
		title: `initStoreState`,
		loadChildren: () => import('./api/api/functions/lxp-api/initStoreState/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Entity',
		title: `Entity`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Entity/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/StoreState',
		title: `StoreState`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/StoreState/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/StoreSelector',
		title: `StoreSelector`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/StoreSelector/page'),
	},
	
	{
		path: 'api/enums/lxp-api/TextSizeWCAG',
		title: `TextSizeWCAG`,
		loadChildren: () => import('./api/api/enums/lxp-api/TextSizeWCAG/page'),
	},
	
	{
		path: 'api/classes/lxp-api/A11yService',
		title: `A11yService`,
		loadChildren: () => import('./api/api/classes/lxp-api/A11yService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ActionOptionHelpersService',
		title: `ActionOptionHelpersService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ActionOptionHelpersService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AnalyticsService',
		title: `AnalyticsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/AnalyticsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ApiServiceBase',
		title: `ApiServiceBase`,
		loadChildren: () => import('./api/api/classes/lxp-api/ApiServiceBase/page'),
	},
	
	{
		path: 'api/variables/lxp-api/LOGIN_ROUTE_PATH',
		title: `LOGIN_ROUTE_PATH`,
		loadChildren: () => import('./api/api/variables/lxp-api/LOGIN_ROUTE_PATH/page'),
	},
	
	{
		path: 'api/variables/lxp-api/UNAUTHORIZED_ROUTE_PATH',
		title: `UNAUTHORIZED_ROUTE_PATH`,
		loadChildren: () => import('./api/api/variables/lxp-api/UNAUTHORIZED_ROUTE_PATH/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AuthService',
		title: `AuthService`,
		loadChildren: () => import('./api/api/classes/lxp-api/AuthService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BreadcrumbsService',
		title: `BreadcrumbsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/BreadcrumbsService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/CareerPathCustomNames',
		title: `CareerPathCustomNames`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/CareerPathCustomNames/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CareerPathNamingService',
		title: `CareerPathNamingService`,
		loadChildren: () => import('./api/api/classes/lxp-api/CareerPathNamingService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ChannelBundleService',
		title: `ChannelBundleService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ChannelBundleService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ChromeMessagingService',
		title: `ChromeMessagingService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ChromeMessagingService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ClipboardService',
		title: `ClipboardService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ClipboardService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ColorService',
		title: `ColorService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ColorService/page'),
	},
	
	{
		path: 'api/functions/lxp-api/consoleProvider',
		title: `consoleProvider`,
		loadChildren: () => import('./api/api/functions/lxp-api/consoleProvider/page'),
	},
	
	{
		path: 'api/variables/lxp-api/CONSOLE',
		title: `CONSOLE`,
		loadChildren: () => import('./api/api/variables/lxp-api/CONSOLE/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContentEditableService',
		title: `ContentEditableService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContentEditableService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContextService',
		title: `ContextService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContextService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DateRange',
		title: `DateRange`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DateRange/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DateRangeService',
		title: `DateRangeService`,
		loadChildren: () => import('./api/api/classes/lxp-api/DateRangeService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DurationConverterService',
		title: `DurationConverterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/DurationConverterService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/EngagedLearner',
		title: `EngagedLearner`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/EngagedLearner/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EngagedLearnerService',
		title: `EngagedLearnerService`,
		loadChildren: () => import('./api/api/classes/lxp-api/EngagedLearnerService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FilterService',
		title: `FilterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/FilterService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FocusStackService',
		title: `FocusStackService`,
		loadChildren: () => import('./api/api/classes/lxp-api/FocusStackService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FollowingService',
		title: `FollowingService`,
		loadChildren: () => import('./api/api/classes/lxp-api/FollowingService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GlobalErrorHandlerService',
		title: `GlobalErrorHandlerService`,
		loadChildren: () => import('./api/api/classes/lxp-api/GlobalErrorHandlerService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/NavigationInfo',
		title: `NavigationInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/NavigationInfo/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GlobalNavigationService',
		title: `GlobalNavigationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/GlobalNavigationService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GoogleAPIs_Books_VolumeResponse',
		title: `GoogleAPIs_Books_VolumeResponse`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GoogleAPIs_Books_VolumeResponse/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GoogleAPIs_Books_Error',
		title: `GoogleAPIs_Books_Error`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GoogleAPIs_Books_Error/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GoogleAPIs_Books_Volume',
		title: `GoogleAPIs_Books_Volume`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GoogleAPIs_Books_Volume/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GoogleAPIs_Books_VolumeInfo',
		title: `GoogleAPIs_Books_VolumeInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GoogleAPIs_Books_VolumeInfo/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GoogleAPIs_Identifier',
		title: `GoogleAPIs_Identifier`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GoogleAPIs_Identifier/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GoogleBooksService',
		title: `GoogleBooksService`,
		loadChildren: () => import('./api/api/classes/lxp-api/GoogleBooksService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OrgNewGroupSettingsInfo',
		title: `OrgNewGroupSettingsInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OrgNewGroupSettingsInfo/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GroupCountChange',
		title: `GroupCountChange`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GroupCountChange/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GroupService',
		title: `GroupService`,
		loadChildren: () => import('./api/api/classes/lxp-api/GroupService/page'),
	},
	
	{
		path: 'api/functions/lxp-api/highchartsLazySingleton',
		title: `highchartsLazySingleton`,
		loadChildren: () => import('./api/api/functions/lxp-api/highchartsLazySingleton/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/HighchartsLazy',
		title: `HighchartsLazy`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/HighchartsLazy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/HIGHCHARTS_LAZY',
		title: `HIGHCHARTS_LAZY`,
		loadChildren: () => import('./api/api/variables/lxp-api/HIGHCHARTS_LAZY/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HighchartsService',
		title: `HighchartsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/HighchartsService/page'),
	},
	
	{
		path: 'api/functions/lxp-api/hlsLazySingleton',
		title: `hlsLazySingleton`,
		loadChildren: () => import('./api/api/functions/lxp-api/hlsLazySingleton/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/HlsLazy',
		title: `HlsLazy`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/HlsLazy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/HLS_LAZY',
		title: `HLS_LAZY`,
		loadChildren: () => import('./api/api/variables/lxp-api/HLS_LAZY/page'),
	},
	
	{
		path: 'api/classes/lxp-api/HttpErrorService',
		title: `HttpErrorService`,
		loadChildren: () => import('./api/api/classes/lxp-api/HttpErrorService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DocumentTitleService',
		title: `DocumentTitleService`,
		loadChildren: () => import('./api/api/classes/lxp-api/DocumentTitleService/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/Unsubscribe',
		title: `Unsubscribe`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/Unsubscribe/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/EmitEvent',
		title: `EmitEvent`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/EmitEvent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/EventRegistrations',
		title: `EventRegistrations`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/EventRegistrations/page'),
	},
	
	{
		path: 'api/variables/lxp-api/destroyEventBus',
		title: `destroyEventBus`,
		loadChildren: () => import('./api/api/variables/lxp-api/destroyEventBus/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EventBus',
		title: `EventBus`,
		loadChildren: () => import('./api/api/classes/lxp-api/EventBus/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LDFlagsService',
		title: `LDFlagsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/LDFlagsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LocaleService',
		title: `LocaleService`,
		loadChildren: () => import('./api/api/classes/lxp-api/LocaleService/page'),
	},
	
	{
		path: 'api/functions/lxp-api/localesLazySingleton',
		title: `localesLazySingleton`,
		loadChildren: () => import('./api/api/functions/lxp-api/localesLazySingleton/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/LocalesLazy',
		title: `LocalesLazy`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/LocalesLazy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/LOCALES_LAZY',
		title: `LOCALES_LAZY`,
		loadChildren: () => import('./api/api/variables/lxp-api/LOCALES_LAZY/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MembersService',
		title: `MembersService`,
		loadChildren: () => import('./api/api/classes/lxp-api/MembersService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ModalInputBindings',
		title: `ModalInputBindings`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ModalInputBindings/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ModalOptions',
		title: `ModalOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ModalOptions/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/CancelNotify',
		title: `CancelNotify`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/CancelNotify/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/NotifyCallback',
		title: `NotifyCallback`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/NotifyCallback/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/NotifyOptions',
		title: `NotifyOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/NotifyOptions/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ModalService',
		title: `ModalService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ModalService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NavigationService',
		title: `NavigationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/NavigationService/page'),
	},
	
	{
		path: 'api/functions/lxp-api/navigatorProvider',
		title: `navigatorProvider`,
		loadChildren: () => import('./api/api/functions/lxp-api/navigatorProvider/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/NavigatorMockable',
		title: `NavigatorMockable`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/NavigatorMockable/page'),
	},
	
	{
		path: 'api/variables/lxp-api/NAVIGATOR',
		title: `NAVIGATOR`,
		loadChildren: () => import('./api/api/variables/lxp-api/NAVIGATOR/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NotifierService',
		title: `NotifierService`,
		loadChildren: () => import('./api/api/classes/lxp-api/NotifierService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Popover',
		title: `Popover`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Popover/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ClosePopoverResult',
		title: `ClosePopoverResult`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ClosePopoverResult/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PopoverService',
		title: `PopoverService`,
		loadChildren: () => import('./api/api/classes/lxp-api/PopoverService/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/PopoverDirection',
		title: `PopoverDirection`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/PopoverDirection/page'),
	},
	
	{
		path: 'api/classes/lxp-api/Positioning',
		title: `Positioning`,
		loadChildren: () => import('./api/api/classes/lxp-api/Positioning/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PreloadService',
		title: `PreloadService`,
		loadChildren: () => import('./api/api/classes/lxp-api/PreloadService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PropertyService',
		title: `PropertyService`,
		loadChildren: () => import('./api/api/classes/lxp-api/PropertyService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/QueueService',
		title: `QueueService`,
		loadChildren: () => import('./api/api/classes/lxp-api/QueueService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SanitizationService',
		title: `SanitizationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SanitizationService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ScrollService',
		title: `ScrollService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ScrollService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchUrlService',
		title: `SearchUrlService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchUrlService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/GlobalSearchUrlParams',
		title: `GlobalSearchUrlParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/GlobalSearchUrlParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ProviderSearchUrlParams',
		title: `ProviderSearchUrlParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ProviderSearchUrlParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PeopleSearchUrlParams',
		title: `PeopleSearchUrlParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PeopleSearchUrlParams/page'),
	},
	
	{
		path: 'api/enums/lxp-api/SearchEvents',
		title: `SearchEvents`,
		loadChildren: () => import('./api/api/enums/lxp-api/SearchEvents/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchEvent',
		title: `SearchEvent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchEvent/page'),
	},
	
	{
		path: 'api/variables/lxp-api/globalSearch',
		title: `globalSearch`,
		loadChildren: () => import('./api/api/variables/lxp-api/globalSearch/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchNavigationService',
		title: `SearchNavigationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchNavigationService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/LOCAL_STORAGE',
		title: `LOCAL_STORAGE`,
		loadChildren: () => import('./api/api/variables/lxp-api/LOCAL_STORAGE/page'),
	},
	
	{
		path: 'api/variables/lxp-api/SESSION_STORAGE',
		title: `SESSION_STORAGE`,
		loadChildren: () => import('./api/api/variables/lxp-api/SESSION_STORAGE/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SubscriptionManagerService',
		title: `SubscriptionManagerService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SubscriptionManagerService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SubscriptionQueueService',
		title: `SubscriptionQueueService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SubscriptionQueueService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SurveyAction',
		title: `SurveyAction`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SurveyAction/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SurveyAndTipsService',
		title: `SurveyAndTipsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SurveyAndTipsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TargetsService',
		title: `TargetsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/TargetsService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TimeZoneDetails',
		title: `TimeZoneDetails`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TimeZoneDetails/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TimeZoneCountry',
		title: `TimeZoneCountry`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TimeZoneCountry/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TimeZoneNames',
		title: `TimeZoneNames`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TimeZoneNames/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TimeZoneService',
		title: `TimeZoneService`,
		loadChildren: () => import('./api/api/classes/lxp-api/TimeZoneService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TrackerService',
		title: `TrackerService`,
		loadChildren: () => import('./api/api/classes/lxp-api/TrackerService/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TrackingProperties',
		title: `TrackingProperties`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TrackingProperties/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingEventArgs',
		title: `TrackingEventArgs`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingEventArgs/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingDetails',
		title: `TrackingDetails`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingDetails/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingContext',
		title: `TrackingContext`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingContext/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingEventData',
		title: `TrackingEventData`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingEventData/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingEventsParams',
		title: `TrackingEventsParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingEventsParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TrackingTimingData',
		title: `TrackingTimingData`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TrackingTimingData/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TransitionMonitorService',
		title: `TransitionMonitorService`,
		loadChildren: () => import('./api/api/classes/lxp-api/TransitionMonitorService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TransitionMonitorEvent',
		title: `TransitionMonitorEvent`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TransitionMonitorEvent/page'),
	},
	
	{
		path: 'api/enums/lxp-api/TransitionType',
		title: `TransitionType`,
		loadChildren: () => import('./api/api/enums/lxp-api/TransitionType/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TranslationHelper',
		title: `TranslationHelper`,
		loadChildren: () => import('./api/api/classes/lxp-api/TranslationHelper/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserEmailAddressesService',
		title: `UserEmailAddressesService`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserEmailAddressesService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserGroupService',
		title: `UserGroupService`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserGroupService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserTourService',
		title: `UserTourService`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserTourService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/VendorIntegrationsService',
		title: `VendorIntegrationsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/VendorIntegrationsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WebEnvironmentService',
		title: `WebEnvironmentService`,
		loadChildren: () => import('./api/api/classes/lxp-api/WebEnvironmentService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardService',
		title: `WizardService`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/wizardInitialState',
		title: `wizardInitialState`,
		loadChildren: () => import('./api/api/variables/lxp-api/wizardInitialState/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WindowLayoutService',
		title: `WindowLayoutService`,
		loadChildren: () => import('./api/api/classes/lxp-api/WindowLayoutService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PathwayAutoEnrollService',
		title: `PathwayAutoEnrollService`,
		loadChildren: () => import('./api/api/classes/lxp-api/PathwayAutoEnrollService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ThemeService',
		title: `ThemeService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ThemeService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/showError',
		title: `showError`,
		loadChildren: () => import('./api/api/variables/lxp-api/showError/page'),
	},
	
	{
		path: 'api/variables/lxp-api/onFormControlUpdate',
		title: `onFormControlUpdate`,
		loadChildren: () => import('./api/api/variables/lxp-api/onFormControlUpdate/page'),
	},
	
	{
		path: 'api/variables/lxp-api/onFormControlReset',
		title: `onFormControlReset`,
		loadChildren: () => import('./api/api/variables/lxp-api/onFormControlReset/page'),
	},
	
	{
		path: 'api/variables/lxp-api/markFormAsTouched',
		title: `markFormAsTouched`,
		loadChildren: () => import('./api/api/variables/lxp-api/markFormAsTouched/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getFormData',
		title: `getFormData`,
		loadChildren: () => import('./api/api/functions/lxp-api/getFormData/page'),
	},
	
	{
		path: 'api/functions/lxp-api/generateCustomId',
		title: `generateCustomId`,
		loadChildren: () => import('./api/api/functions/lxp-api/generateCustomId/page'),
	},
	
	{
		path: 'api/functions/lxp-api/catchAndRedirectError',
		title: `catchAndRedirectError`,
		loadChildren: () => import('./api/api/functions/lxp-api/catchAndRedirectError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/catchAndSurfaceError',
		title: `catchAndSurfaceError`,
		loadChildren: () => import('./api/api/functions/lxp-api/catchAndSurfaceError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/safeEncodeURIComponent',
		title: `safeEncodeURIComponent`,
		loadChildren: () => import('./api/api/functions/lxp-api/safeEncodeURIComponent/page'),
	},
	
	{
		path: 'api/functions/lxp-api/markUnchangedStringAsPristine',
		title: `markUnchangedStringAsPristine`,
		loadChildren: () => import('./api/api/functions/lxp-api/markUnchangedStringAsPristine/page'),
	},
	
	{
		path: 'api/functions/lxp-api/warnCharPercentLimited',
		title: `warnCharPercentLimited`,
		loadChildren: () => import('./api/api/functions/lxp-api/warnCharPercentLimited/page'),
	},
	
	{
		path: 'api/variables/lxp-api/HTTP_URL_PATTERN',
		title: `HTTP_URL_PATTERN`,
		loadChildren: () => import('./api/api/variables/lxp-api/HTTP_URL_PATTERN/page'),
	},
	
	{
		path: 'api/variables/lxp-api/HTTP_REQUIRED_URL_PATTERN',
		title: `HTTP_REQUIRED_URL_PATTERN`,
		loadChildren: () => import('./api/api/variables/lxp-api/HTTP_REQUIRED_URL_PATTERN/page'),
	},
	
	{
		path: 'api/variables/lxp-api/HTTPS_REQUIRED_URL_PATTERN',
		title: `HTTPS_REQUIRED_URL_PATTERN`,
		loadChildren: () => import('./api/api/variables/lxp-api/HTTPS_REQUIRED_URL_PATTERN/page'),
	},
	
	{
		path: 'api/variables/lxp-api/CUSTOM_SCHEME_URL_PATTERN',
		title: `CUSTOM_SCHEME_URL_PATTERN`,
		loadChildren: () => import('./api/api/variables/lxp-api/CUSTOM_SCHEME_URL_PATTERN/page'),
	},
	
	{
		path: 'api/functions/lxp-api/fuzzyFilter',
		title: `fuzzyFilter`,
		loadChildren: () => import('./api/api/functions/lxp-api/fuzzyFilter/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FuzzyFilterOptions',
		title: `FuzzyFilterOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FuzzyFilterOptions/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/KeyOrOptions',
		title: `KeyOrOptions`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/KeyOrOptions/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getCurrentOrigin',
		title: `getCurrentOrigin`,
		loadChildren: () => import('./api/api/functions/lxp-api/getCurrentOrigin/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TranslateFn',
		title: `TranslateFn`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TranslateFn/page'),
	},
	
	{
		path: 'api/variables/lxp-api/translateWithDefaults',
		title: `translateWithDefaults`,
		loadChildren: () => import('./api/api/variables/lxp-api/translateWithDefaults/page'),
	},
	
	{
		path: 'api/variables/lxp-api/buildTranslateFn',
		title: `buildTranslateFn`,
		loadChildren: () => import('./api/api/variables/lxp-api/buildTranslateFn/page'),
	},
	
	{
		path: 'api/functions/lxp-api/booleanFromString',
		title: `booleanFromString`,
		loadChildren: () => import('./api/api/functions/lxp-api/booleanFromString/page'),
	},
	
	{
		path: 'api/functions/lxp-api/capitalizeFirstLetter',
		title: `capitalizeFirstLetter`,
		loadChildren: () => import('./api/api/functions/lxp-api/capitalizeFirstLetter/page'),
	},
	
	{
		path: 'api/variables/lxp-api/debounce',
		title: `debounce`,
		loadChildren: () => import('./api/api/variables/lxp-api/debounce/page'),
	},
	
	{
		path: 'api/functions/lxp-api/deleteUndefinedOrNull',
		title: `deleteUndefinedOrNull`,
		loadChildren: () => import('./api/api/functions/lxp-api/deleteUndefinedOrNull/page'),
	},
	
	{
		path: 'api/variables/lxp-api/deepEqual',
		title: `deepEqual`,
		loadChildren: () => import('./api/api/variables/lxp-api/deepEqual/page'),
	},
	
	{
		path: 'api/functions/lxp-api/groupBy',
		title: `groupBy`,
		loadChildren: () => import('./api/api/functions/lxp-api/groupBy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isEmpty',
		title: `isEmpty`,
		loadChildren: () => import('./api/api/variables/lxp-api/isEmpty/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isUrlAbsolute',
		title: `isUrlAbsolute`,
		loadChildren: () => import('./api/api/functions/lxp-api/isUrlAbsolute/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isUrlValid',
		title: `isUrlValid`,
		loadChildren: () => import('./api/api/functions/lxp-api/isUrlValid/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isPlainObject',
		title: `isPlainObject`,
		loadChildren: () => import('./api/api/variables/lxp-api/isPlainObject/page'),
	},
	
	{
		path: 'api/functions/lxp-api/numberFromString',
		title: `numberFromString`,
		loadChildren: () => import('./api/api/functions/lxp-api/numberFromString/page'),
	},
	
	{
		path: 'api/variables/lxp-api/orderBy',
		title: `orderBy`,
		loadChildren: () => import('./api/api/variables/lxp-api/orderBy/page'),
	},
	
	{
		path: 'api/functions/lxp-api/remove',
		title: `remove`,
		loadChildren: () => import('./api/api/functions/lxp-api/remove/page'),
	},
	
	{
		path: 'api/functions/lxp-api/sanitizeUserInput',
		title: `sanitizeUserInput`,
		loadChildren: () => import('./api/api/functions/lxp-api/sanitizeUserInput/page'),
	},
	
	{
		path: 'api/functions/lxp-api/search',
		title: `search`,
		loadChildren: () => import('./api/api/functions/lxp-api/search/page'),
	},
	
	{
		path: 'api/functions/lxp-api/searchAndOrderBy',
		title: `searchAndOrderBy`,
		loadChildren: () => import('./api/api/functions/lxp-api/searchAndOrderBy/page'),
	},
	
	{
		path: 'api/functions/lxp-api/shortenBigNumber',
		title: `shortenBigNumber`,
		loadChildren: () => import('./api/api/functions/lxp-api/shortenBigNumber/page'),
	},
	
	{
		path: 'api/variables/lxp-api/sortBy',
		title: `sortBy`,
		loadChildren: () => import('./api/api/variables/lxp-api/sortBy/page'),
	},
	
	{
		path: 'api/functions/lxp-api/sortDate',
		title: `sortDate`,
		loadChildren: () => import('./api/api/functions/lxp-api/sortDate/page'),
	},
	
	{
		path: 'api/variables/lxp-api/startCase',
		title: `startCase`,
		loadChildren: () => import('./api/api/variables/lxp-api/startCase/page'),
	},
	
	{
		path: 'api/functions/lxp-api/lazyAttr',
		title: `lazyAttr`,
		loadChildren: () => import('./api/api/functions/lxp-api/lazyAttr/page'),
	},
	
	{
		path: 'api/functions/lxp-api/catchAndSurfaceModalFocusError',
		title: `catchAndSurfaceModalFocusError`,
		loadChildren: () => import('./api/api/functions/lxp-api/catchAndSurfaceModalFocusError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/catchAndSurfaceNonModalError',
		title: `catchAndSurfaceNonModalError`,
		loadChildren: () => import('./api/api/functions/lxp-api/catchAndSurfaceNonModalError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isModalDismissError',
		title: `isModalDismissError`,
		loadChildren: () => import('./api/api/functions/lxp-api/isModalDismissError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isModalFocusError',
		title: `isModalFocusError`,
		loadChildren: () => import('./api/api/functions/lxp-api/isModalFocusError/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isTrueModalError',
		title: `isTrueModalError`,
		loadChildren: () => import('./api/api/functions/lxp-api/isTrueModalError/page'),
	},
	
	{
		path: 'api/variables/lxp-api/MODAL_FOCUS_ERROR',
		title: `MODAL_FOCUS_ERROR`,
		loadChildren: () => import('./api/api/variables/lxp-api/MODAL_FOCUS_ERROR/page'),
	},
	
	{
		path: 'api/variables/lxp-api/pick',
		title: `pick`,
		loadChildren: () => import('./api/api/variables/lxp-api/pick/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getNestedPropertyValue',
		title: `getNestedPropertyValue`,
		loadChildren: () => import('./api/api/variables/lxp-api/getNestedPropertyValue/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getProperty',
		title: `getProperty`,
		loadChildren: () => import('./api/api/variables/lxp-api/getProperty/page'),
	},
	
	{
		path: 'api/variables/lxp-api/setProperty',
		title: `setProperty`,
		loadChildren: () => import('./api/api/variables/lxp-api/setProperty/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ReinterpretKeys',
		title: `ReinterpretKeys`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ReinterpretKeys/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getDeepCopy',
		title: `getDeepCopy`,
		loadChildren: () => import('./api/api/variables/lxp-api/getDeepCopy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/set',
		title: `set`,
		loadChildren: () => import('./api/api/variables/lxp-api/set/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getNestedObject',
		title: `getNestedObject`,
		loadChildren: () => import('./api/api/variables/lxp-api/getNestedObject/page'),
	},
	
	{
		path: 'api/variables/lxp-api/pascalCaseKeys',
		title: `pascalCaseKeys`,
		loadChildren: () => import('./api/api/variables/lxp-api/pascalCaseKeys/page'),
	},
	
	{
		path: 'api/variables/lxp-api/camelCaseKeys',
		title: `camelCaseKeys`,
		loadChildren: () => import('./api/api/variables/lxp-api/camelCaseKeys/page'),
	},
	
	{
		path: 'api/variables/lxp-api/appendQueryParams',
		title: `appendQueryParams`,
		loadChildren: () => import('./api/api/variables/lxp-api/appendQueryParams/page'),
	},
	
	{
		path: 'api/functions/lxp-api/ensureLoggedIn',
		title: `ensureLoggedIn`,
		loadChildren: () => import('./api/api/functions/lxp-api/ensureLoggedIn/page'),
	},
	
	{
		path: 'api/functions/lxp-api/ensureLoggedInAnd',
		title: `ensureLoggedInAnd`,
		loadChildren: () => import('./api/api/functions/lxp-api/ensureLoggedInAnd/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getParentSnapshotData',
		title: `getParentSnapshotData`,
		loadChildren: () => import('./api/api/functions/lxp-api/getParentSnapshotData/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getParentSnapshotParam',
		title: `getParentSnapshotParam`,
		loadChildren: () => import('./api/api/functions/lxp-api/getParentSnapshotParam/page'),
	},
	
	{
		path: 'api/functions/lxp-api/delayAtLeast',
		title: `delayAtLeast`,
		loadChildren: () => import('./api/api/functions/lxp-api/delayAtLeast/page'),
	},
	
	{
		path: 'api/functions/lxp-api/readFirst',
		title: `readFirst`,
		loadChildren: () => import('./api/api/functions/lxp-api/readFirst/page'),
	},
	
	{
		path: 'api/functions/lxp-api/readFirstAsync',
		title: `readFirstAsync`,
		loadChildren: () => import('./api/api/functions/lxp-api/readFirstAsync/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/Selector',
		title: `Selector`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/Selector/page'),
	},
	
	{
		path: 'api/functions/lxp-api/loadWith',
		title: `loadWith`,
		loadChildren: () => import('./api/api/functions/lxp-api/loadWith/page'),
	},
	
	{
		path: 'api/functions/lxp-api/lazySearch',
		title: `lazySearch`,
		loadChildren: () => import('./api/api/functions/lxp-api/lazySearch/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Loadable',
		title: `Loadable`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Loadable/page'),
	},
	
	{
		path: 'api/functions/lxp-api/compareTap',
		title: `compareTap`,
		loadChildren: () => import('./api/api/functions/lxp-api/compareTap/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/CompareTapFn',
		title: `CompareTapFn`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/CompareTapFn/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getTagLevel',
		title: `getTagLevel`,
		loadChildren: () => import('./api/api/functions/lxp-api/getTagLevel/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getTagLevelLabel',
		title: `getTagLevelLabel`,
		loadChildren: () => import('./api/api/functions/lxp-api/getTagLevelLabel/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isMatchingTag',
		title: `isMatchingTag`,
		loadChildren: () => import('./api/api/functions/lxp-api/isMatchingTag/page'),
	},
	
	{
		path: 'api/functions/lxp-api/hasExternalRating',
		title: `hasExternalRating`,
		loadChildren: () => import('./api/api/functions/lxp-api/hasExternalRating/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getPendingManagerRating',
		title: `getPendingManagerRating`,
		loadChildren: () => import('./api/api/functions/lxp-api/getPendingManagerRating/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getPendingEvaluation',
		title: `getPendingEvaluation`,
		loadChildren: () => import('./api/api/functions/lxp-api/getPendingEvaluation/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getPendingSelfRating',
		title: `getPendingSelfRating`,
		loadChildren: () => import('./api/api/functions/lxp-api/getPendingSelfRating/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getTagCompletedRatings',
		title: `getTagCompletedRatings`,
		loadChildren: () => import('./api/api/functions/lxp-api/getTagCompletedRatings/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getCompletedRatings',
		title: `getCompletedRatings`,
		loadChildren: () => import('./api/api/functions/lxp-api/getCompletedRatings/page'),
	},
	
	{
		path: 'api/functions/lxp-api/tagHasRedactedRatings',
		title: `tagHasRedactedRatings`,
		loadChildren: () => import('./api/api/functions/lxp-api/tagHasRedactedRatings/page'),
	},
	
	{
		path: 'api/functions/lxp-api/tagHasPublicRatings',
		title: `tagHasPublicRatings`,
		loadChildren: () => import('./api/api/functions/lxp-api/tagHasPublicRatings/page'),
	},
	
	{
		path: 'api/functions/lxp-api/tagHasIncompleteRatingsForType',
		title: `tagHasIncompleteRatingsForType`,
		loadChildren: () => import('./api/api/functions/lxp-api/tagHasIncompleteRatingsForType/page'),
	},
	
	{
		path: 'api/functions/lxp-api/tagsHaveRatingsForType',
		title: `tagsHaveRatingsForType`,
		loadChildren: () => import('./api/api/functions/lxp-api/tagsHaveRatingsForType/page'),
	},
	
	{
		path: 'api/functions/lxp-api/getAverageRatingLevel',
		title: `getAverageRatingLevel`,
		loadChildren: () => import('./api/api/functions/lxp-api/getAverageRatingLevel/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isRatingTypeAvailable',
		title: `isRatingTypeAvailable`,
		loadChildren: () => import('./api/api/functions/lxp-api/isRatingTypeAvailable/page'),
	},
	
	{
		path: 'api/variables/lxp-api/INTERNAL_RATINGS_ORDER',
		title: `INTERNAL_RATINGS_ORDER`,
		loadChildren: () => import('./api/api/variables/lxp-api/INTERNAL_RATINGS_ORDER/page'),
	},
	
	{
		path: 'api/functions/lxp-api/msToTimeString',
		title: `msToTimeString`,
		loadChildren: () => import('./api/api/functions/lxp-api/msToTimeString/page'),
	},
	
	{
		path: 'api/functions/lxp-api/ngbDateToJsMonth',
		title: `ngbDateToJsMonth`,
		loadChildren: () => import('./api/api/functions/lxp-api/ngbDateToJsMonth/page'),
	},
	
	{
		path: 'api/functions/lxp-api/ngbDateToJsDate',
		title: `ngbDateToJsDate`,
		loadChildren: () => import('./api/api/functions/lxp-api/ngbDateToJsDate/page'),
	},
	
	{
		path: 'api/functions/lxp-api/jsDateToNgbDate',
		title: `jsDateToNgbDate`,
		loadChildren: () => import('./api/api/functions/lxp-api/jsDateToNgbDate/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isFunction',
		title: `isFunction`,
		loadChildren: () => import('./api/api/functions/lxp-api/isFunction/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isBoolean',
		title: `isBoolean`,
		loadChildren: () => import('./api/api/functions/lxp-api/isBoolean/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isDate',
		title: `isDate`,
		loadChildren: () => import('./api/api/functions/lxp-api/isDate/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isReplyCommentModel',
		title: `isReplyCommentModel`,
		loadChildren: () => import('./api/api/variables/lxp-api/isReplyCommentModel/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/UnionToIntersection',
		title: `UnionToIntersection`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/UnionToIntersection/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/RecursivePartial',
		title: `RecursivePartial`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/RecursivePartial/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/Merge',
		title: `Merge`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/Merge/page'),
	},
	
	{
		path: 'api/functions/lxp-api/generateGuid',
		title: `generateGuid`,
		loadChildren: () => import('./api/api/functions/lxp-api/generateGuid/page'),
	},
	
	{
		path: 'api/functions/lxp-api/privacyNumFromPrivacyLevel',
		title: `privacyNumFromPrivacyLevel`,
		loadChildren: () => import('./api/api/functions/lxp-api/privacyNumFromPrivacyLevel/page'),
	},
	
	{
		path: 'api/enums/lxp-api/CatalogSource',
		title: `CatalogSource`,
		loadChildren: () => import('./api/api/enums/lxp-api/CatalogSource/page'),
	},
	
	{
		path: 'api/variables/lxp-api/shouldPerformAutoEnrollment',
		title: `shouldPerformAutoEnrollment`,
		loadChildren: () => import('./api/api/variables/lxp-api/shouldPerformAutoEnrollment/page'),
	},
	
	{
		path: 'api/variables/lxp-api/ngbTypeaheadInputFormatter',
		title: `ngbTypeaheadInputFormatter`,
		loadChildren: () => import('./api/api/variables/lxp-api/ngbTypeaheadInputFormatter/page'),
	},
	
	{
		path: 'api/variables/lxp-api/ngbTypeaheadInputFormatterMultiField',
		title: `ngbTypeaheadInputFormatterMultiField`,
		loadChildren: () => import('./api/api/variables/lxp-api/ngbTypeaheadInputFormatterMultiField/page'),
	},
	
	{
		path: 'api/variables/lxp-api/trackBy',
		title: `trackBy`,
		loadChildren: () => import('./api/api/variables/lxp-api/trackBy/page'),
	},
	
	{
		path: 'api/variables/lxp-api/trackById',
		title: `trackById`,
		loadChildren: () => import('./api/api/variables/lxp-api/trackById/page'),
	},
	
	{
		path: 'api/variables/lxp-api/trackByIndex',
		title: `trackByIndex`,
		loadChildren: () => import('./api/api/variables/lxp-api/trackByIndex/page'),
	},
	
	{
		path: 'api/functions/lxp-api/hasBrokenUrlValidator',
		title: `hasBrokenUrlValidator`,
		loadChildren: () => import('./api/api/functions/lxp-api/hasBrokenUrlValidator/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isCharLimitedValidator',
		title: `isCharLimitedValidator`,
		loadChildren: () => import('./api/api/functions/lxp-api/isCharLimitedValidator/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isEmptyObjectValidator',
		title: `isEmptyObjectValidator`,
		loadChildren: () => import('./api/api/variables/lxp-api/isEmptyObjectValidator/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isEmptyValidator',
		title: `isEmptyValidator`,
		loadChildren: () => import('./api/api/variables/lxp-api/isEmptyValidator/page'),
	},
	
	{
		path: 'api/functions/lxp-api/isUrlValidator',
		title: `isUrlValidator`,
		loadChildren: () => import('./api/api/functions/lxp-api/isUrlValidator/page'),
	},
	
	{
		path: 'api/variables/lxp-api/Locales',
		title: `Locales`,
		loadChildren: () => import('./api/api/variables/lxp-api/Locales/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ActionButtonComponent',
		title: `ActionButtonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ActionButtonComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ActionButtonSize',
		title: `ActionButtonSize`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ActionButtonSize/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ActionButtonLinkComponent',
		title: `ActionButtonLinkComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ActionButtonLinkComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InputCompletionComponent',
		title: `InputCompletionComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/InputCompletionComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ThumbsComponent',
		title: `ThumbsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ThumbsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ViewAcademyComponent',
		title: `ViewAcademyComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ViewAcademyComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AddTileComponent',
		title: `AddTileComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/AddTileComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AddressSuggestComponent',
		title: `AddressSuggestComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/AddressSuggestComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/LocalityViewModel',
		title: `LocalityViewModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/LocalityViewModel/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AddressSuggestService',
		title: `AddressSuggestService`,
		loadChildren: () => import('./api/api/classes/lxp-api/AddressSuggestService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AppHeader',
		title: `AppHeader`,
		loadChildren: () => import('./api/api/classes/lxp-api/AppHeader/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AssignmentBadgeComponent',
		title: `AssignmentBadgeComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/AssignmentBadgeComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Breadcrumb',
		title: `Breadcrumb`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Breadcrumb/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Breadcrumbs',
		title: `Breadcrumbs`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Breadcrumbs/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BreadcrumbsComponent',
		title: `BreadcrumbsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/BreadcrumbsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BulkActionsComponent',
		title: `BulkActionsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/BulkActionsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BulkActionService',
		title: `BulkActionService`,
		loadChildren: () => import('./api/api/classes/lxp-api/BulkActionService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CardComponent',
		title: `CardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/CardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CharacterLimitInputComponent',
		title: `CharacterLimitInputComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/CharacterLimitInputComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ColumnConfiguratorComponent',
		title: `ColumnConfiguratorComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ColumnConfiguratorComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ColumnConfiguration',
		title: `ColumnConfiguration`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ColumnConfiguration/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ComboboxComponent',
		title: `ComboboxComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ComboboxComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ComboboxOption',
		title: `ComboboxOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ComboboxOption/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ConfettiDropperComponent',
		title: `ConfettiDropperComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ConfettiDropperComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiParticle',
		title: `ConfettiParticle`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiParticle/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiParticleOptions',
		title: `ConfettiParticleOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiParticleOptions/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiAnimationOptions',
		title: `ConfettiAnimationOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiAnimationOptions/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiParticleSetPositionOptions',
		title: `ConfettiParticleSetPositionOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiParticleSetPositionOptions/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiParticleStepOptions',
		title: `ConfettiParticleStepOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiParticleStepOptions/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ConfettiParticleRepositionOptions',
		title: `ConfettiParticleRepositionOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ConfettiParticleRepositionOptions/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ConfettiDropperService',
		title: `ConfettiDropperService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ConfettiDropperService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ConnectWithMentorButtonComponent',
		title: `ConnectWithMentorButtonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ConnectWithMentorButtonComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CookieBannerComponent',
		title: `CookieBannerComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/CookieBannerComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CookieBannerModule',
		title: `CookieBannerModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/CookieBannerModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CopyLinkComponent',
		title: `CopyLinkComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/CopyLinkComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxCopyLinkModule',
		title: `DgxCopyLinkModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxCopyLinkModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataTableComponent',
		title: `DataTableComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataTableComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/CaptionConfig',
		title: `CaptionConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/CaptionConfig/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/DataColumnType',
		title: `DataColumnType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/DataColumnType/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumn',
		title: `DataColumn`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumn/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnDate',
		title: `DataColumnDate`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnDate/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnHighlight',
		title: `DataColumnHighlight`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnHighlight/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnList',
		title: `DataColumnList`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnList/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnMenu',
		title: `DataColumnMenu`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnMenu/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnPerson',
		title: `DataColumnPerson`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnPerson/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataColumnProgressBar',
		title: `DataColumnProgressBar`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataColumnProgressBar/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/MenuSettings',
		title: `MenuSettings`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/MenuSettings/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/BaseColumn',
		title: `BaseColumn`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/BaseColumn/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PopoverConfig',
		title: `PopoverConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PopoverConfig/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/HeaderIcon',
		title: `HeaderIcon`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/HeaderIcon/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DataTableInputCallback',
		title: `DataTableInputCallback`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DataTableInputCallback/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DatePickerComponent',
		title: `DatePickerComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DatePickerComponent/page'),
	},
	
	{
		path: 'api/functions/lxp-api/endDateValidator',
		title: `endDateValidator`,
		loadChildren: () => import('./api/api/functions/lxp-api/endDateValidator/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DateRangeComponent',
		title: `DateRangeComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DateRangeComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DownloadButtonComponent',
		title: `DownloadButtonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DownloadButtonComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DynamicGridManifestBuilder',
		title: `DynamicGridManifestBuilder`,
		loadChildren: () => import('./api/api/classes/lxp-api/DynamicGridManifestBuilder/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DynamicGridComponent',
		title: `DynamicGridComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DynamicGridComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ViewModel',
		title: `ViewModel`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ViewModel/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/APILayoutSchema',
		title: `APILayoutSchema`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/APILayoutSchema/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/APIComponentSchema',
		title: `APIComponentSchema`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/APIComponentSchema/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ViewLayoutSchema',
		title: `ViewLayoutSchema`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ViewLayoutSchema/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ViewComponentSchema',
		title: `ViewComponentSchema`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ViewComponentSchema/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/StaticComponentRef',
		title: `StaticComponentRef`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/StaticComponentRef/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/AsyncComponentRef',
		title: `AsyncComponentRef`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/AsyncComponentRef/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ComponentManifest',
		title: `ComponentManifest`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ComponentManifest/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/AsyncConfig',
		title: `AsyncConfig`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/AsyncConfig/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/StaticConfig',
		title: `StaticConfig`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/StaticConfig/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/TransformFn',
		title: `TransformFn`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/TransformFn/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/LoadFn',
		title: `LoadFn`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/LoadFn/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DynamicGridModule',
		title: `DynamicGridModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DynamicGridModule/page'),
	},
	
	{
		path: 'api/variables/lxp-api/DynamicGridComponentManifestToken',
		title: `DynamicGridComponentManifestToken`,
		loadChildren: () => import('./api/api/variables/lxp-api/DynamicGridComponentManifestToken/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getColumnClasses',
		title: `getColumnClasses`,
		loadChildren: () => import('./api/api/variables/lxp-api/getColumnClasses/page'),
	},
	
	{
		path: 'api/variables/lxp-api/loadDynamicGridComponents',
		title: `loadDynamicGridComponents`,
		loadChildren: () => import('./api/api/variables/lxp-api/loadDynamicGridComponents/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isValidComponent',
		title: `isValidComponent`,
		loadChildren: () => import('./api/api/variables/lxp-api/isValidComponent/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isValidColumn',
		title: `isValidColumn`,
		loadChildren: () => import('./api/api/variables/lxp-api/isValidColumn/page'),
	},
	
	{
		path: 'api/variables/lxp-api/mapComponents',
		title: `mapComponents`,
		loadChildren: () => import('./api/api/variables/lxp-api/mapComponents/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getAsyncComponentRef',
		title: `getAsyncComponentRef`,
		loadChildren: () => import('./api/api/variables/lxp-api/getAsyncComponentRef/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EngagedCongratulationsModalComponent',
		title: `EngagedCongratulationsModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/EngagedCongratulationsModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EngagedLearnerModalComponent',
		title: `EngagedLearnerModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/EngagedLearnerModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ExpandingTitleSectionComponent',
		title: `ExpandingTitleSectionComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ExpandingTitleSectionComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FilteredFacet',
		title: `FilteredFacet`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FilteredFacet/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FilteredFacetValue',
		title: `FilteredFacetValue`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FilteredFacetValue/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Filter',
		title: `Filter`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Filter/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FilterIcon',
		title: `FilterIcon`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FilterIcon/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/FacetFilter',
		title: `FacetFilter`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/FacetFilter/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FilterComponent',
		title: `FilterComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/FilterComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FinraTextareaLimitComponent',
		title: `FinraTextareaLimitComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/FinraTextareaLimitComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FooterGlassesComponent',
		title: `FooterGlassesComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/FooterGlassesComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ForbiddenComponent',
		title: `ForbiddenComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ForbiddenComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/FullPageModalComponent',
		title: `FullPageModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/FullPageModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GroupSearchComponent',
		title: `GroupSearchComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/GroupSearchComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxGroupSearchModule',
		title: `DgxGroupSearchModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxGroupSearchModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GroupsEditComponent',
		title: `GroupsEditComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/GroupsEditComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxGroupsEditModule',
		title: `DgxGroupsEditModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxGroupsEditModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/BulkIconRegistryComponent',
		title: `BulkIconRegistryComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/BulkIconRegistryComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Icon',
		title: `Icon`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Icon/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ImageLayoutComponent',
		title: `ImageLayoutComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ImageLayoutComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InputStatisticsComponent',
		title: `InputStatisticsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/InputStatisticsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InsightsCardComponent',
		title: `InsightsCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/InsightsCardComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/InsightCardViewModel',
		title: `InsightCardViewModel`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/InsightCardViewModel/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InsightsCardService',
		title: `InsightsCardService`,
		loadChildren: () => import('./api/api/classes/lxp-api/InsightsCardService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LazyChunkComponent',
		title: `LazyChunkComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LazyChunkComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LinkRowComponent',
		title: `LinkRowComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LinkRowComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/LinkRowLink',
		title: `LinkRowLink`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/LinkRowLink/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ListItemComponent',
		title: `ListItemComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ListItemComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/MenuViewModel',
		title: `MenuViewModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/MenuViewModel/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/ModifyOptionsFnType',
		title: `ModifyOptionsFnType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/ModifyOptionsFnType/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MenuComponent',
		title: `MenuComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/MenuComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxMenuModule',
		title: `DgxMenuModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxMenuModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ModalComponent',
		title: `ModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ModalModule',
		title: `ModalModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/ModalModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MonthPickerComponent',
		title: `MonthPickerComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/MonthPickerComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NoSearchResultsComponent',
		title: `NoSearchResultsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/NoSearchResultsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/NotFoundComponent',
		title: `NotFoundComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/NotFoundComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/User',
		title: `User`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/User/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OpportunityProviderModel',
		title: `OpportunityProviderModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OpportunityProviderModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OpportunityMatchesModel',
		title: `OpportunityMatchesModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OpportunityMatchesModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OpportunitySkillModel',
		title: `OpportunitySkillModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OpportunitySkillModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OpportunityCardModel',
		title: `OpportunityCardModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OpportunityCardModel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/OpportunityModel',
		title: `OpportunityModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/OpportunityModel/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OpportunityCardComponent',
		title: `OpportunityCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/OpportunityCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OptionalNavigationComponent',
		title: `OptionalNavigationComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/OptionalNavigationComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/Mode',
		title: `Mode`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/Mode/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrgAnnouncementsComponent',
		title: `OrgAnnouncementsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrgAnnouncementsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrgAnnouncementsModule',
		title: `OrgAnnouncementsModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrgAnnouncementsModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrgSelectorComponent',
		title: `OrgSelectorComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrgSelectorComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PageSaveFooterComponent',
		title: `PageSaveFooterComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PageSaveFooterComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PaginationComponent',
		title: `PaginationComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PaginationComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PerPageOptions',
		title: `PerPageOptions`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PerPageOptions/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PanelListComponent',
		title: `PanelListComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PanelListComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PillSelectorComponent',
		title: `PillSelectorComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PillSelectorComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PillOption',
		title: `PillOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PillOption/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PopoverTriggerDirective',
		title: `PopoverTriggerDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/PopoverTriggerDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PopoverComponent',
		title: `PopoverComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PopoverComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/CatalogTypeOption',
		title: `CatalogTypeOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/CatalogTypeOption/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PopularProvidersComponent',
		title: `PopularProvidersComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/PopularProvidersComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ProfileMenuViewModel',
		title: `ProfileMenuViewModel`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ProfileMenuViewModel/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfileMenuComponent',
		title: `ProfileMenuComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfileMenuComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfileEngagementComponent',
		title: `ProfileEngagementComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfileEngagementComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfilePicFallbackService',
		title: `ProfilePicFallbackService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfilePicFallbackService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/AVATAR_FONT_FAMILY',
		title: `AVATAR_FONT_FAMILY`,
		loadChildren: () => import('./api/api/variables/lxp-api/AVATAR_FONT_FAMILY/page'),
	},
	
	{
		path: 'api/enums/lxp-api/ProfilePicSize',
		title: `ProfilePicSize`,
		loadChildren: () => import('./api/api/enums/lxp-api/ProfilePicSize/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfilePicComponent',
		title: `ProfilePicComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfilePicComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfilePicModule',
		title: `ProfilePicModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfilePicModule/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ProgressCircleConfig',
		title: `ProgressCircleConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ProgressCircleConfig/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProgressCircleComponent',
		title: `ProgressCircleComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProgressCircleComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProviderComponent',
		title: `ProviderComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProviderComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/RatingSliderComponent',
		title: `RatingSliderComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/RatingSliderComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReactiveFormsLabelComponent',
		title: `ReactiveFormsLabelComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReactiveFormsLabelComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ResourceResultComponent',
		title: `ResourceResultComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ResourceResultComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/SelectTemplateOption',
		title: `SelectTemplateOption`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/SelectTemplateOption/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SelectOption',
		title: `SelectOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SelectOption/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Option',
		title: `Option`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Option/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SelectComponent',
		title: `SelectComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SelectComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SelectReactiveComponent',
		title: `SelectReactiveComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SelectReactiveComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SignalPopoverComponent',
		title: `SignalPopoverComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SignalPopoverComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkillStandardsCardComponent',
		title: `SkillStandardsCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkillStandardsCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkillStandardsPublishStatusBadgeComponent',
		title: `SkillStandardsPublishStatusBadgeComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkillStandardsPublishStatusBadgeComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkillStandardsSegmentCardComponent',
		title: `SkillStandardsSegmentCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkillStandardsSegmentCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkipNavComponent',
		title: `SkipNavComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkipNavComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SocialCounts',
		title: `SocialCounts`,
		loadChildren: () => import('./api/api/classes/lxp-api/SocialCounts/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SocialCountsService',
		title: `SocialCountsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/SocialCountsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SocialPicsComponent',
		title: `SocialPicsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SocialPicsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SplitButtonComponent',
		title: `SplitButtonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SplitButtonComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/StickyFilterBarComponent',
		title: `StickyFilterBarComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/StickyFilterBarComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SubscriberBaseDirective',
		title: `SubscriberBaseDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/SubscriberBaseDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TaskAlertComponent',
		title: `TaskAlertComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/TaskAlertComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TextExpanderComponent',
		title: `TextExpanderComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/TextExpanderComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ThSortComponent',
		title: `ThSortComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ThSortComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/TimeZonePickerComponent',
		title: `TimeZonePickerComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/TimeZonePickerComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DfToastConfig',
		title: `DfToastConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DfToastConfig/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ToastComponent',
		title: `ToastComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ToastComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ToggleElementComponent',
		title: `ToggleElementComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ToggleElementComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ToggleSwitchComponent',
		title: `ToggleSwitchComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ToggleSwitchComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserCardComponent',
		title: `UserCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserRecommendationHeaderModule',
		title: `UserRecommendationHeaderModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserRecommendationHeaderModule/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/UserRecommendationHeaderItem',
		title: `UserRecommendationHeaderItem`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/UserRecommendationHeaderItem/page'),
	},
	
	{
		path: 'api/enums/lxp-api/SourceUserType',
		title: `SourceUserType`,
		loadChildren: () => import('./api/api/enums/lxp-api/SourceUserType/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserRecommendationHeaderComponent',
		title: `UserRecommendationHeaderComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserRecommendationHeaderComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UsersPicturesComponent',
		title: `UsersPicturesComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/UsersPicturesComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ValidateFieldComponent',
		title: `ValidateFieldComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ValidateFieldComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/VideoPlayerComponent',
		title: `VideoPlayerComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/VideoPlayerComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/VisibilityComponent',
		title: `VisibilityComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/VisibilityComponent/page'),
	},
	
	{
		path: 'api/enums/lxp-api/Visibility',
		title: `Visibility`,
		loadChildren: () => import('./api/api/enums/lxp-api/Visibility/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/VisibilityItem',
		title: `VisibilityItem`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/VisibilityItem/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/VisibilityOption',
		title: `VisibilityOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/VisibilityOption/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/VisibilityURLOption',
		title: `VisibilityURLOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/VisibilityURLOption/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxVisibilityModule',
		title: `DgxVisibilityModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxVisibilityModule/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/WizardSteps',
		title: `WizardSteps`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/WizardSteps/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/WizardStep',
		title: `WizardStep`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/WizardStep/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/WizardPosition',
		title: `WizardPosition`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/WizardPosition/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/WizardLinkLevel',
		title: `WizardLinkLevel`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/WizardLinkLevel/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/WizardState',
		title: `WizardState`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/WizardState/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ItemContainerRoleDirective',
		title: `ItemContainerRoleDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/ItemContainerRoleDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ItemRoleDirective',
		title: `ItemRoleDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/ItemRoleDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxItemRoleModule',
		title: `DgxItemRoleModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxItemRoleModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LineClampDirective',
		title: `LineClampDirective`,
		loadChildren: () => import('./api/api/classes/lxp-api/LineClampDirective/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxLineClampModule',
		title: `DgxLineClampModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxLineClampModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MiniProfilerInterceptor',
		title: `MiniProfilerInterceptor`,
		loadChildren: () => import('./api/api/classes/lxp-api/MiniProfilerInterceptor/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PageCoordinator',
		title: `PageCoordinator`,
		loadChildren: () => import('./api/api/classes/lxp-api/PageCoordinator/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/FormRenderManager',
		title: `FormRenderManager`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/FormRenderManager/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InputsRepository',
		title: `InputsRepository`,
		loadChildren: () => import('./api/api/classes/lxp-api/InputsRepository/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Repository',
		title: `Repository`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Repository/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserInputsRepository',
		title: `UserInputsRepository`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserInputsRepository/page'),
	},
	
	{
		path: 'api/classes/lxp-api/A11yToolbarService',
		title: `A11yToolbarService`,
		loadChildren: () => import('./api/api/classes/lxp-api/A11yToolbarService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/mapAuthUserPermissions',
		title: `mapAuthUserPermissions`,
		loadChildren: () => import('./api/api/variables/lxp-api/mapAuthUserPermissions/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AutoSaveService',
		title: `AutoSaveService`,
		loadChildren: () => import('./api/api/classes/lxp-api/AutoSaveService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ConfigurationService',
		title: `ConfigurationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ConfigurationService/page'),
	},
	
	{
		path: 'api/enums/lxp-api/UrlHostWhiteList',
		title: `UrlHostWhiteList`,
		loadChildren: () => import('./api/api/enums/lxp-api/UrlHostWhiteList/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContentDurationService',
		title: `ContentDurationService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContentDurationService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DetailsModalConfig',
		title: `DetailsModalConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DetailsModalConfig/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DetailsModalService',
		title: `DetailsModalService`,
		loadChildren: () => import('./api/api/classes/lxp-api/DetailsModalService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/UserOrGroupSearchItem',
		title: `UserOrGroupSearchItem`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/UserOrGroupSearchItem/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserGroupListService',
		title: `UserGroupListService`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserGroupListService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CustomAdapterService',
		title: `CustomAdapterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/CustomAdapterService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CustomDateParserFormatterService',
		title: `CustomDateParserFormatterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/CustomDateParserFormatterService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MediumDateParserFormatterService',
		title: `MediumDateParserFormatterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/MediumDateParserFormatterService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MonthDateParserFormatterService',
		title: `MonthDateParserFormatterService`,
		loadChildren: () => import('./api/api/classes/lxp-api/MonthDateParserFormatterService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ChartsLDFlags',
		title: `ChartsLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/ChartsLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InputsLDFlags',
		title: `InputsLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/InputsLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InsightsLDFlags',
		title: `InsightsLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/InsightsLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/MentoringLDFlags',
		title: `MentoringLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/MentoringLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrgManagementLDFlags',
		title: `OrgManagementLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrgManagementLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/PathwaysLDFLags',
		title: `PathwaysLDFLags`,
		loadChildren: () => import('./api/api/classes/lxp-api/PathwaysLDFLags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfileLDFlags',
		title: `ProfileLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfileLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReportingLDFlags',
		title: `ReportingLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReportingLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchLDFlags',
		title: `SearchLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkillCoachLDFlags',
		title: `SkillCoachLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkillCoachLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SkillsLDFlags',
		title: `SkillsLDFlags`,
		loadChildren: () => import('./api/api/classes/lxp-api/SkillsLDFlags/page'),
	},
	
	{
		path: 'api/classes/lxp-api/OrgHomeConfigApiService',
		title: `OrgHomeConfigApiService`,
		loadChildren: () => import('./api/api/classes/lxp-api/OrgHomeConfigApiService/page'),
	},
	
	{
		path: 'api/enums/lxp-api/RecommendationSection',
		title: `RecommendationSection`,
		loadChildren: () => import('./api/api/enums/lxp-api/RecommendationSection/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/UserProfileRecommendationCounts',
		title: `UserProfileRecommendationCounts`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/UserProfileRecommendationCounts/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/UserProfileRecommendationCountTotals',
		title: `UserProfileRecommendationCountTotals`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/UserProfileRecommendationCountTotals/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ProfileRecommendationCountsService',
		title: `ProfileRecommendationCountsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ProfileRecommendationCountsService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/addTotal',
		title: `addTotal`,
		loadChildren: () => import('./api/api/variables/lxp-api/addTotal/page'),
	},
	
	{
		path: 'api/enums/lxp-api/LearnerInsightType',
		title: `LearnerInsightType`,
		loadChildren: () => import('./api/api/enums/lxp-api/LearnerInsightType/page'),
	},
	
	{
		path: 'api/enums/lxp-api/ProviderCatalogType',
		title: `ProviderCatalogType`,
		loadChildren: () => import('./api/api/enums/lxp-api/ProviderCatalogType/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/CompletionParams',
		title: `CompletionParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/CompletionParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TopLearnerInsightsParams',
		title: `TopLearnerInsightsParams`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TopLearnerInsightsParams/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/Group',
		title: `Group`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/Group/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/InsightKPI',
		title: `InsightKPI`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/InsightKPI/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/PopularProvider',
		title: `PopularProvider`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/PopularProvider/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TargetPathwayContent',
		title: `TargetPathwayContent`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TargetPathwayContent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TargetSkillsInfo',
		title: `TargetSkillsInfo`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TargetSkillsInfo/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TargetSkillsInsights',
		title: `TargetSkillsInsights`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TargetSkillsInsights/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/TopLearnerInsights',
		title: `TopLearnerInsights`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/TopLearnerInsights/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReportingService',
		title: `ReportingService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReportingService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ReportingContentService',
		title: `ReportingContentService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ReportingContentService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ResourceImageJson',
		title: `ResourceImageJson`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ResourceImageJson/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ResourceImageCropData',
		title: `ResourceImageCropData`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ResourceImageCropData/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/ResourceImage',
		title: `ResourceImage`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/ResourceImage/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ResourceImageService',
		title: `ResourceImageService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ResourceImageService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/LazyTranslationBundleToken',
		title: `LazyTranslationBundleToken`,
		loadChildren: () => import('./api/api/variables/lxp-api/LazyTranslationBundleToken/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LazyTranslationBundleResolver',
		title: `LazyTranslationBundleResolver`,
		loadChildren: () => import('./api/api/classes/lxp-api/LazyTranslationBundleResolver/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/UserPreferences',
		title: `UserPreferences`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/UserPreferences/page'),
	},
	
	{
		path: 'api/classes/lxp-api/UserPreferencesService',
		title: `UserPreferencesService`,
		loadChildren: () => import('./api/api/classes/lxp-api/UserPreferencesService/page'),
	},
	
	{
		path: 'api/variables/lxp-api/validMonthShortNames',
		title: `validMonthShortNames`,
		loadChildren: () => import('./api/api/variables/lxp-api/validMonthShortNames/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getMonthNumericValue',
		title: `getMonthNumericValue`,
		loadChildren: () => import('./api/api/variables/lxp-api/getMonthNumericValue/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getLocalizedMonthLongName',
		title: `getLocalizedMonthLongName`,
		loadChildren: () => import('./api/api/variables/lxp-api/getLocalizedMonthLongName/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getLocalizedMonthShortName',
		title: `getLocalizedMonthShortName`,
		loadChildren: () => import('./api/api/variables/lxp-api/getLocalizedMonthShortName/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getLocalizedDate',
		title: `getLocalizedDate`,
		loadChildren: () => import('./api/api/variables/lxp-api/getLocalizedDate/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getLocalizedDateRange',
		title: `getLocalizedDateRange`,
		loadChildren: () => import('./api/api/variables/lxp-api/getLocalizedDateRange/page'),
	},
	
	{
		path: 'api/variables/lxp-api/formatDateTimeToLocal',
		title: `formatDateTimeToLocal`,
		loadChildren: () => import('./api/api/variables/lxp-api/formatDateTimeToLocal/page'),
	},
	
	{
		path: 'api/variables/lxp-api/resourceTypeIcon',
		title: `resourceTypeIcon`,
		loadChildren: () => import('./api/api/variables/lxp-api/resourceTypeIcon/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isSkillsClient',
		title: `isSkillsClient`,
		loadChildren: () => import('./api/api/variables/lxp-api/isSkillsClient/page'),
	},
	
	{
		path: 'api/variables/lxp-api/isUserAPathwayCollaborator',
		title: `isUserAPathwayCollaborator`,
		loadChildren: () => import('./api/api/variables/lxp-api/isUserAPathwayCollaborator/page'),
	},
	
	{
		path: 'api/variables/lxp-api/nonChannelBulkPathwaysPermissions',
		title: `nonChannelBulkPathwaysPermissions`,
		loadChildren: () => import('./api/api/variables/lxp-api/nonChannelBulkPathwaysPermissions/page'),
	},
	
	{
		path: 'api/variables/lxp-api/canViewPathwayInsights',
		title: `canViewPathwayInsights`,
		loadChildren: () => import('./api/api/variables/lxp-api/canViewPathwayInsights/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContentCardComponent',
		title: `ContentCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContentCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ContentCardService',
		title: `ContentCardService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ContentCardService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LearningResourceCardComponent',
		title: `LearningResourceCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LearningResourceCardComponent/page'),
	},
	
	{
		path: 'api/enums/lxp-api/Expanded',
		title: `Expanded`,
		loadChildren: () => import('./api/api/enums/lxp-api/Expanded/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LearningResourceCardService',
		title: `LearningResourceCardService`,
		loadChildren: () => import('./api/api/classes/lxp-api/LearningResourceCardService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ResourceCardMenuService',
		title: `ResourceCardMenuService`,
		loadChildren: () => import('./api/api/classes/lxp-api/ResourceCardMenuService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/MetadataConfig',
		title: `MetadataConfig`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/MetadataConfig/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LearningResourceMetadataComponent',
		title: `LearningResourceMetadataComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LearningResourceMetadataComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LiveEventsService',
		title: `LiveEventsService`,
		loadChildren: () => import('./api/api/classes/lxp-api/LiveEventsService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/EndorseContentService',
		title: `EndorseContentService`,
		loadChildren: () => import('./api/api/classes/lxp-api/EndorseContentService/page'),
	},
	
	{
		path: 'api/classes/lxp-api/CookieLawService',
		title: `CookieLawService`,
		loadChildren: () => import('./api/api/classes/lxp-api/CookieLawService/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/BulkAction',
		title: `BulkAction`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/BulkAction/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataBulkActionsComponent',
		title: `DataBulkActionsComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataBulkActionsComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataFiltersComponent',
		title: `DataFiltersComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataFiltersComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataSearchComponent',
		title: `DataSearchComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataSearchComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SimpleFieldWrapperComponent',
		title: `SimpleFieldWrapperComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SimpleFieldWrapperComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DgxSimpleFieldWrapperModule',
		title: `DgxSimpleFieldWrapperModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/DgxSimpleFieldWrapperModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/GroupSearchInputComponent',
		title: `GroupSearchInputComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/GroupSearchInputComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/InputComponent',
		title: `InputComponent`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/InputComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ActivityInsightsCardComponent',
		title: `ActivityInsightsCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ActivityInsightsCardComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/InsightActivityMetric',
		title: `InsightActivityMetric`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/InsightActivityMetric/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getTitleKey',
		title: `getTitleKey`,
		loadChildren: () => import('./api/api/variables/lxp-api/getTitleKey/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getDescriptionKey',
		title: `getDescriptionKey`,
		loadChildren: () => import('./api/api/variables/lxp-api/getDescriptionKey/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getDeltaDescriptionKey',
		title: `getDeltaDescriptionKey`,
		loadChildren: () => import('./api/api/variables/lxp-api/getDeltaDescriptionKey/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getMetricLabelKey',
		title: `getMetricLabelKey`,
		loadChildren: () => import('./api/api/variables/lxp-api/getMetricLabelKey/page'),
	},
	
	{
		path: 'api/variables/lxp-api/getA11yMetricLabelKey',
		title: `getA11yMetricLabelKey`,
		loadChildren: () => import('./api/api/variables/lxp-api/getA11yMetricLabelKey/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AssignedLearningInsightsCardComponent',
		title: `AssignedLearningInsightsCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/AssignedLearningInsightsCardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LinkInsightsCardComponent',
		title: `LinkInsightsCardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LinkInsightsCardComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/AlertModalInputs',
		title: `AlertModalInputs`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/AlertModalInputs/page'),
	},
	
	{
		path: 'api/classes/lxp-api/AlertModalComponent',
		title: `AlertModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/AlertModalComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/DeleteModalInputs',
		title: `DeleteModalInputs`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/DeleteModalInputs/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DeleteModalComponent',
		title: `DeleteModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DeleteModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DeleteMultiConfirmationModalComponent',
		title: `DeleteMultiConfirmationModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DeleteMultiConfirmationModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ModalFooterComponent',
		title: `ModalFooterComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ModalFooterComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/HeadingMetaOption',
		title: `HeadingMetaOption`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/HeadingMetaOption/page'),
	},
	
	{
		path: 'api/classes/lxp-api/ModalHeaderComponent',
		title: `ModalHeaderComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/ModalHeaderComponent/page'),
	},
	
	{
		path: 'api/interfaces/lxp-api/SimpleModalInputBindings',
		title: `SimpleModalInputBindings`,
		loadChildren: () => import('./api/api/interfaces/lxp-api/SimpleModalInputBindings/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SimpleModalComponent',
		title: `SimpleModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SimpleModalComponent/page'),
	},
	
	{
		path: 'api/type-aliases/lxp-api/SearchFieldWrapperType',
		title: `SearchFieldWrapperType`,
		loadChildren: () => import('./api/api/type-aliases/lxp-api/SearchFieldWrapperType/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SearchFieldWrapperComponent',
		title: `SearchFieldWrapperComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SearchFieldWrapperComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/SplitButtonMenuItemComponent',
		title: `SplitButtonMenuItemComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/SplitButtonMenuItemComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardComponent',
		title: `WizardComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardModule',
		title: `WizardModule`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardModule/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardNavigationComponent',
		title: `WizardNavigationComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardNavigationComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardTitleComponent',
		title: `WizardTitleComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardTitleComponent/page'),
	},
	
	{
		path: 'api/variables/lxp-api/opportunitiesMapper',
		title: `opportunitiesMapper`,
		loadChildren: () => import('./api/api/variables/lxp-api/opportunitiesMapper/page'),
	},
	
	{
		path: 'api/variables/lxp-api/reportingMapper',
		title: `reportingMapper`,
		loadChildren: () => import('./api/api/variables/lxp-api/reportingMapper/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LiveEventMetadataComponent',
		title: `LiveEventMetadataComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LiveEventMetadataComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/LiveEventSessionComponent',
		title: `LiveEventSessionComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/LiveEventSessionComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataBulkActionButtonComponent',
		title: `DataBulkActionButtonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataBulkActionButtonComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataColumnDateComponent',
		title: `DataColumnDateComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataColumnDateComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataColumnHighlightComponent',
		title: `DataColumnHighlightComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataColumnHighlightComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataColumnListComponent',
		title: `DataColumnListComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataColumnListComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataColumnPersonComponent',
		title: `DataColumnPersonComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataColumnPersonComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/DataColumnVisibilityComponent',
		title: `DataColumnVisibilityComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/DataColumnVisibilityComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InviteFlowModalComponent',
		title: `InviteFlowModalComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/InviteFlowModalComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardStepComponent',
		title: `WizardStepComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardStepComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/WizardStepLabelComponent',
		title: `WizardStepLabelComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/WizardStepLabelComponent/page'),
	},
	
	{
		path: 'api/classes/lxp-api/InviteFlowComponent',
		title: `InviteFlowComponent`,
		loadChildren: () => import('./api/api/classes/lxp-api/InviteFlowComponent/page'),
	},
	
	{
		path: 'api/functions/fresco-api/formlyTranslationConfigFactory',
		title: `formlyTranslationConfigFactory`,
		loadChildren: () => import('./api/api/functions/fresco-api/formlyTranslationConfigFactory/page'),
	},
	
	{
		path: 'api/variables/fresco-api/DF_COMMON_FORMS_CONFIG',
		title: `DF_COMMON_FORMS_CONFIG`,
		loadChildren: () => import('./api/api/variables/fresco-api/DF_COMMON_FORMS_CONFIG/page'),
	},
	
	{
		path: 'api/variables/fresco-api/FORMLY_TRANSLATIONS_CONFIG_PROVIDER',
		title: `FORMLY_TRANSLATIONS_CONFIG_PROVIDER`,
		loadChildren: () => import('./api/api/variables/fresco-api/FORMLY_TRANSLATIONS_CONFIG_PROVIDER/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/ValidationMessageOption',
		title: `ValidationMessageOption`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/ValidationMessageOption/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/IndexedAsyncValidators',
		title: `IndexedAsyncValidators`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/IndexedAsyncValidators/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/IndexedValidators',
		title: `IndexedValidators`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/IndexedValidators/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFieldTemplateContext',
		title: `DfFieldTemplateContext`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFieldTemplateContext/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormFieldConfig',
		title: `DfFormFieldConfig`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormFieldConfig/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfTemplateOptions',
		title: `DfTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFieldAddOn',
		title: `DfFieldAddOn`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFieldAddOn/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFieldButtonAddOn',
		title: `DfFieldButtonAddOn`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFieldButtonAddOn/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfFormNonNumericInputType',
		title: `DfFormNonNumericInputType`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfFormNonNumericInputType/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfFormNumericInputType',
		title: `DfFormNumericInputType`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfFormNumericInputType/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfFormTextInputType',
		title: `DfFormTextInputType`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfFormTextInputType/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfFormInputAutocomplete',
		title: `DfFormInputAutocomplete`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfFormInputAutocomplete/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormTextTemplateOptions',
		title: `DfFormTextTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormTextTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfPlaceholdableTemplateOptions',
		title: `DfPlaceholdableTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfPlaceholdableTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormTextareaTemplateOptions',
		title: `DfFormTextareaTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormTextareaTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormNumericTemplateOptions',
		title: `DfFormNumericTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormNumericTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormDateTemplateOptions',
		title: `DfFormDateTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormDateTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormCustomTemplateOptions',
		title: `DfFormCustomTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormCustomTemplateOptions/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormForeignTemplateOptions',
		title: `DfFormForeignTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormForeignTemplateOptions/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfTextFieldConfig',
		title: `DfTextFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfTextFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfTextInputFieldConfig',
		title: `DfTextInputFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfTextInputFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfNumericInputFieldConfig',
		title: `DfNumericInputFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfNumericInputFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfTextareaFieldConfig',
		title: `DfTextareaFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfTextareaFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfToggleSwitchFieldConfig',
		title: `DfToggleSwitchFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfToggleSwitchFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfCheckboxFieldConfig',
		title: `DfCheckboxFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfCheckboxFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfCustomFieldConfig',
		title: `DfCustomFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfCustomFieldConfig/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfForeignFieldConfig',
		title: `DfForeignFieldConfig`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfForeignFieldConfig/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFieldsetTemplateOptions',
		title: `DfFieldsetTemplateOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFieldsetTemplateOptions/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfFieldLayout',
		title: `DfFieldLayout`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfFieldLayout/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfFormOptions',
		title: `DfFormOptions`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfFormOptions/page'),
	},
	
	{
		path: 'api/classes/fresco-api/FormlyTranslateExtension',
		title: `FormlyTranslateExtension`,
		loadChildren: () => import('./api/api/classes/fresco-api/FormlyTranslateExtension/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormlyModule',
		title: `DfFormlyModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormlyModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormFieldBuilder',
		title: `DfFormFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfConfiguredFormFieldBuilder',
		title: `DfConfiguredFormFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfConfiguredFormFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextareaFieldBuilder',
		title: `DfTextareaFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextareaFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextInputFieldBuilder',
		title: `DfTextInputFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextInputFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfNumericInputFieldBuilder',
		title: `DfNumericInputFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfNumericInputFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFieldGroupBuilder',
		title: `DfFieldGroupBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFieldGroupBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFieldsetBuilder',
		title: `DfFieldsetBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFieldsetBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormCustomFieldComponent',
		title: `DfFormCustomFieldComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormCustomFieldComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormRootComponent',
		title: `DfFormRootComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormRootComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfDgatFieldTypeDirective',
		title: `DfDgatFieldTypeDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfDgatFieldTypeDirective/page'),
	},
	
	{
		path: 'api/functions/fresco-api/dfWordCountValidator',
		title: `dfWordCountValidator`,
		loadChildren: () => import('./api/api/functions/fresco-api/dfWordCountValidator/page'),
	},
	
	{
		path: 'api/functions/fresco-api/dfFieldMatchValidator',
		title: `dfFieldMatchValidator`,
		loadChildren: () => import('./api/api/functions/fresco-api/dfFieldMatchValidator/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormsModule',
		title: `DfFormsModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormsModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonsModule',
		title: `DfButtonsModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonsModule/page'),
	},
	
	{
		path: 'api/variables/fresco-api/BUTTON_ACTION_STYLES',
		title: `BUTTON_ACTION_STYLES`,
		loadChildren: () => import('./api/api/variables/fresco-api/BUTTON_ACTION_STYLES/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonActionComponent',
		title: `DfButtonActionComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonActionComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonActionModule',
		title: `DfButtonActionModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonActionModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonBasicComponent',
		title: `DfButtonBasicComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonBasicComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonBasicModule',
		title: `DfButtonBasicModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonBasicModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonSplitModule',
		title: `DfButtonSplitModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonSplitModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonSplitComponent',
		title: `DfButtonSplitComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonSplitComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfButtonSplitMenuItemComponent',
		title: `DfButtonSplitMenuItemComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfButtonSplitMenuItemComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfInputsModule',
		title: `DfInputsModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfInputsModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfCheckboxComponent',
		title: `DfCheckboxComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfCheckboxComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfCheckboxModule',
		title: `DfCheckboxModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfCheckboxModule/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfPresentationalInputAddOnType',
		title: `DfPresentationalInputAddOnType`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfPresentationalInputAddOnType/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfInputAddOnType',
		title: `DfInputAddOnType`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfInputAddOnType/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfInputDecoratorComponent',
		title: `DfInputDecoratorComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfInputDecoratorComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfInputDecoratorModule',
		title: `DfInputDecoratorModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfInputDecoratorModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextareaModule',
		title: `DfTextareaModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextareaModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextareaComponent',
		title: `DfTextareaComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextareaComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextInputModule',
		title: `DfTextInputModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextInputModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextInputComponent',
		title: `DfTextInputComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextInputComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfControlValueModule',
		title: `DfControlValueModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfControlValueModule/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfControlEvent',
		title: `DfControlEvent`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfControlEvent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfControlValueDirective',
		title: `DfControlValueDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfControlValueDirective/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfInputDebounceModule',
		title: `DfInputDebounceModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfInputDebounceModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfInputDebounceDirective',
		title: `DfInputDebounceDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfInputDebounceDirective/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfAutofocusModule',
		title: `DfAutofocusModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfAutofocusModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfAutofocusDirective',
		title: `DfAutofocusDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfAutofocusDirective/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfToggleSwitchComponent',
		title: `DfToggleSwitchComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfToggleSwitchComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfToggleSwitchModule',
		title: `DfToggleSwitchModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfToggleSwitchModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfLabelMarkerModule',
		title: `DfLabelMarkerModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfLabelMarkerModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfLabelMarkerComponent',
		title: `DfLabelMarkerComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfLabelMarkerComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfLocalNotificationModule',
		title: `DfLocalNotificationModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfLocalNotificationModule/page'),
	},
	
	{
		path: 'api/enums/fresco-api/NotificationType',
		title: `NotificationType`,
		loadChildren: () => import('./api/api/enums/fresco-api/NotificationType/page'),
	},
	
	{
		path: 'api/variables/fresco-api/NotificationTypeIconMap',
		title: `NotificationTypeIconMap`,
		loadChildren: () => import('./api/api/variables/fresco-api/NotificationTypeIconMap/page'),
	},
	
	{
		path: 'api/variables/fresco-api/NotificationSizeIconMap',
		title: `NotificationSizeIconMap`,
		loadChildren: () => import('./api/api/variables/fresco-api/NotificationSizeIconMap/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfLocalNotificationComponent',
		title: `DfLocalNotificationComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfLocalNotificationComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPillSelectorComponent',
		title: `DfPillSelectorComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPillSelectorComponent/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfToggleOption',
		title: `DfToggleOption`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfToggleOption/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPillSelectorModule',
		title: `DfPillSelectorModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPillSelectorModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPlaceholdersModule',
		title: `DfPlaceholdersModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPlaceholdersModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSpinnerButtonModule',
		title: `DfSpinnerButtonModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSpinnerButtonModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSpinnerButtonComponent',
		title: `DfSpinnerButtonComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSpinnerButtonComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSpinnerModule',
		title: `DfSpinnerModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSpinnerModule/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/SpinnerContext',
		title: `SpinnerContext`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/SpinnerContext/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSpinnerComponent',
		title: `DfSpinnerComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSpinnerComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPopoverModule',
		title: `DfPopoverModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPopoverModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPopoverComponent',
		title: `DfPopoverComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPopoverComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPopoverTriggerDirective',
		title: `DfPopoverTriggerDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPopoverTriggerDirective/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfPopover',
		title: `DfPopover`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfPopover/page'),
	},
	
	{
		path: 'api/interfaces/fresco-api/DfClosePopoverResult',
		title: `DfClosePopoverResult`,
		loadChildren: () => import('./api/api/interfaces/fresco-api/DfClosePopoverResult/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPopoverService',
		title: `DfPopoverService`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPopoverService/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSearchModule',
		title: `DfSearchModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSearchModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSearchBoxModule',
		title: `DfSearchBoxModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSearchBoxModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfSearchBoxComponent',
		title: `DfSearchBoxComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfSearchBoxComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfUtilitiesModule',
		title: `DfUtilitiesModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfUtilitiesModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfAccessibilityModule',
		title: `DfAccessibilityModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfAccessibilityModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfAccessibilityReaderService',
		title: `DfAccessibilityReaderService`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfAccessibilityReaderService/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfAccessibilityService',
		title: `DfAccessibilityService`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfAccessibilityService/page'),
	},
	
	{
		path: 'api/variables/fresco-api/DF_SLIDE_FADE_IN_LEFT',
		title: `DF_SLIDE_FADE_IN_LEFT`,
		loadChildren: () => import('./api/api/variables/fresco-api/DF_SLIDE_FADE_IN_LEFT/page'),
	},
	
	{
		path: 'api/variables/fresco-api/DF_COLLAPSE_EXPAND',
		title: `DF_COLLAPSE_EXPAND`,
		loadChildren: () => import('./api/api/variables/fresco-api/DF_COLLAPSE_EXPAND/page'),
	},
	
	{
		path: 'api/functions/fresco-api/isKey',
		title: `isKey`,
		loadChildren: () => import('./api/api/functions/fresco-api/isKey/page'),
	},
	
	{
		path: 'api/enums/fresco-api/Key',
		title: `Key`,
		loadChildren: () => import('./api/api/enums/fresco-api/Key/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfLayoutModule',
		title: `DfLayoutModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfLayoutModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFocusStackService',
		title: `DfFocusStackService`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFocusStackService/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfPlacement',
		title: `DfPlacement`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfPlacement/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfPopoverDirection',
		title: `DfPopoverDirection`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfPopoverDirection/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfPlacementArray',
		title: `DfPlacementArray`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfPlacementArray/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfElementPosition',
		title: `DfElementPosition`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfElementPosition/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPositioningService',
		title: `DfPositioningService`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPositioningService/page'),
	},
	
	{
		path: 'api/variables/fresco-api/positionService',
		title: `positionService`,
		loadChildren: () => import('./api/api/variables/fresco-api/positionService/page'),
	},
	
	{
		path: 'api/classes/fresco-api/IdGeneratorService',
		title: `IdGeneratorService`,
		loadChildren: () => import('./api/api/classes/fresco-api/IdGeneratorService/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfPipesModule',
		title: `DfPipesModule`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfPipesModule/page'),
	},
	
	{
		path: 'api/classes/fresco-api/PrefixPipe',
		title: `PrefixPipe`,
		loadChildren: () => import('./api/api/classes/fresco-api/PrefixPipe/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfStringProviderPipe',
		title: `DfStringProviderPipe`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfStringProviderPipe/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfRequirableFormFieldBuilder',
		title: `DfRequirableFormFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfRequirableFormFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfTextFieldBuilder',
		title: `DfTextFieldBuilder`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfTextFieldBuilder/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfContentProviderDirective',
		title: `DfContentProviderDirective`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfContentProviderDirective/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfStringProvider',
		title: `DfStringProvider`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfStringProvider/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfDynamicContentRef',
		title: `DfDynamicContentRef`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfDynamicContentRef/page'),
	},
	
	{
		path: 'api/type-aliases/fresco-api/DfDynamicContentProvider',
		title: `DfDynamicContentProvider`,
		loadChildren: () => import('./api/api/type-aliases/fresco-api/DfDynamicContentProvider/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFieldWrapperComponent',
		title: `DfFieldWrapperComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFieldWrapperComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFieldsetComponent',
		title: `DfFieldsetComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFieldsetComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormCheckboxComponent',
		title: `DfFormCheckboxComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormCheckboxComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormTextInputComponent',
		title: `DfFormTextInputComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormTextInputComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormTextareaComponent',
		title: `DfFormTextareaComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormTextareaComponent/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DfFormToggleSwitchComponent',
		title: `DfFormToggleSwitchComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DfFormToggleSwitchComponent/page'),
	},
	
	{
		path: 'api/functions/fresco-api/countWords',
		title: `countWords`,
		loadChildren: () => import('./api/api/functions/fresco-api/countWords/page'),
	},
	
	{
		path: 'api/functions/fresco-api/isFunction',
		title: `isFunction`,
		loadChildren: () => import('./api/api/functions/fresco-api/isFunction/page'),
	},
	
	{
		path: 'api/functions/fresco-api/isString',
		title: `isString`,
		loadChildren: () => import('./api/api/functions/fresco-api/isString/page'),
	},
	
	{
		path: 'api/classes/fresco-api/DemoSearchBoxReactiveComponent',
		title: `DemoSearchBoxReactiveComponent`,
		loadChildren: () => import('./api/api/classes/fresco-api/DemoSearchBoxReactiveComponent/page'),
	},
	
	{
		path: 'fresco',
		title: `Fresco`,
		children: [{
			path: '',
			redirectTo: 'fresco',
			pathMatch: 'full'
		},
	{
		path: 'fresco',
		title: `Fresco`,
		loadChildren: () => import('./guides/app/docs/fresco/page'),
	},
	{
		path: 'local-notification',
		title: `Local Notification`,
		loadChildren: () => import('./guides/app/docs/fresco/local-notification/page'),
	},],
	},
	
	{
		path: 'src',
		title: `Apollo`,
		children: [{
			path: '',
			redirectTo: 'badges',
			pathMatch: 'full'
		},
	{
		path: 'badges',
		title: `Badges`,
		loadChildren: () => import('./guides/apollo/src/components/badges/page'),
	},
	{
		path: 'alert',
		title: `Alert`,
		loadChildren: () => import('./guides/apollo/src/components/alert/page'),
	},
	{
		path: 'drawer',
		title: `Drawer`,
		loadChildren: () => import('./guides/apollo/src/components/drawer/page'),
	},
	{
		path: 'icons',
		title: `Icons`,
		loadChildren: () => import('./guides/apollo/src/icons/page'),
	},
	{
		path: 'buttons',
		title: `Buttons`,
		loadChildren: () => import('./guides/apollo/src/components/buttons/page'),
	},
	{
		path: 'avatar',
		title: `Avatar`,
		loadChildren: () => import('./guides/apollo/src/components/avatar/page'),
	},
	{
		path: 'skip-nav',
		title: `Skip Nav`,
		loadChildren: () => import('./guides/apollo/src/components/skip-nav/page'),
	},
	{
		path: 'confirm',
		title: `Modal: Confirm`,
		loadChildren: () => import('./guides/apollo/src/components/confirm/page'),
	},
	{
		path: 'radio-buttons',
		title: `Radio Buttons`,
		loadChildren: () => import('./guides/apollo/src/components/radio-buttons/page'),
	},
	{
		path: 'tabs',
		title: `Tabs`,
		loadChildren: () => import('./guides/apollo/src/components/tabs/page'),
	},
	{
		path: 'breadcrumb',
		title: `Breadcrumb`,
		loadChildren: () => import('./guides/apollo/src/components/breadcrumb/page'),
	},
	{
		path: 'toast',
		title: `Toast`,
		loadChildren: () => import('./guides/apollo/src/components/toast/page'),
	},
	{
		path: 'text-input',
		title: `Input`,
		loadChildren: () => import('./guides/apollo/src/components/text-input/page'),
	},
	{
		path: 'dropdown',
		title: `Dropdown`,
		loadChildren: () => import('./guides/apollo/src/components/dropdown/page'),
	},
	{
		path: 'pagination',
		title: `Pagination`,
		loadChildren: () => import('./guides/apollo/src/components/pagination/page'),
	},
	{
		path: 'textarea',
		title: `Textarea`,
		loadChildren: () => import('./guides/apollo/src/components/textarea/page'),
	},
	{
		path: 'layout-v3',
		title: `V3 Navigation`,
		loadChildren: () => import('./guides/apollo/src/components/layout-v3/page'),
	},],
	},
	
	{
		path: 'lxp-shared',
		title: `LXP Shared`,
		children: [{
			path: '',
			redirectTo: 'combobox',
			pathMatch: 'full'
		},
	{
		path: 'combobox',
		title: `Dgx Combobox`,
		loadChildren: () => import('./guides/app/docs/lxp-shared/combobox/page'),
	},],
	},
];
